// JavaScript Document
const strLink1="https://interior-arne.com/products/"
function setGoods(url,haba,depth,height,color,form){
this.url=url;
this.haba=haba;
this.depth=depth;
this.height=height;
this.color=color;
this.form=form;
}
function searchURL(){
var habaValue=document.getElementById("haba").value;
var depthValue=document.getElementById("depth").value;
var heightValue=document.getElementById("height").value;
var idColor = document.getElementsByName( "colortype" ) ;
for ( colorValue="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
  colorValue = idColor[i].id ;
  break ;
 }
}
if(habaValue=="haba-select" && depthValue=="depth-selected" && heightValue=="height-selected"){
alert("「幅・奥行・高さ」を選んでください");
return false;
}
if(habaValue=="haba-select" && depthValue=="depth-selected"){
alert("「幅・奥行」を選んでください");
return false;
}
if(habaValue=="haba-select" && heightValue=="height-selected"){
alert("「幅・高さ」を選んでください");
return false;
}
if(depthValue=="depth-selected" && heightValue=="height-selected"){
alert("「奥行・高さ」を選んでください");
return false;
}
if(habaValue=="haba-select"){
alert("「幅」を選んでください");
return false;
}
if(depthValue=="depth-selected"){
alert("「奥行」を選んでください");
return false;
}
if(heightValue=="height-selected"){
alert("「高さ」を選んでください");
return false;
}
if(colorValue==""){
alert("「カラー」を選んでください");
return false;
}
var url=document.getElementById("link_url");
for(var i in goods){
if(goods[i].haba==habaValue && goods[i].depth==depthValue && goods[i].height==heightValue && goods[i].color==colorValue){
return goods[i].url;
}
}
alert("ご希望サイズ幅"+habaValue+"cm×奥行"+depthValue+"cm×高さ"+heightValue+"cmは購入ページのご用意がございません。\nお手数をおかけしますがお見積りを出しますので当店までお問合せくださいませ。");
return false;
}
function jump(){
var idColor = document.getElementsByName( "colortype" ) ;
for ( strColor="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
  strColor = idColor[i].id ;
  var valueColor = idColor[i].value ;
  break ;
 }
}
var url=searchURL();
if(!url){
return false;
}
window.open(strLink1+url)
return false;
}
goods = new Object();
goods[0] =new setGoods("0000a68774","90","30","30","wood","normal");
goods[1] =new setGoods("0000a68781","95","30","30","wood","normal");
goods[2] =new setGoods("0000a68788","100","30","30","wood","normal");
goods[3] =new setGoods("0000a68795","105","30","30","wood","normal");
goods[4] =new setGoods("0000a68802","110","30","30","wood","normal");
goods[5] =new setGoods("0000a68809","115","30","30","wood","normal");
goods[6] =new setGoods("0000a68816","120","30","30","wood","normal");
goods[7] =new setGoods("0000a68823","125","30","30","wood","normal");
goods[8] =new setGoods("0000a68830","130","30","30","wood","normal");
goods[9] =new setGoods("0000a68837","135","30","30","wood","normal");
goods[10] =new setGoods("0000a68844","140","30","30","wood","normal");
goods[11] =new setGoods("0000a68851","145","30","30","wood","normal");
goods[12] =new setGoods("0000a68858","150","30","30","wood","normal");
goods[13] =new setGoods("0000a68865","90","35","30","wood","normal");
goods[14] =new setGoods("0000a68872","95","35","30","wood","normal");
goods[15] =new setGoods("0000a68879","100","35","30","wood","normal");
goods[16] =new setGoods("0000a68886","105","35","30","wood","normal");
goods[17] =new setGoods("0000a68893","110","35","30","wood","normal");
goods[18] =new setGoods("0000a68900","115","35","30","wood","normal");
goods[19] =new setGoods("0000a68907","120","35","30","wood","normal");
goods[20] =new setGoods("0000a68914","125","35","30","wood","normal");
goods[21] =new setGoods("0000a68921","130","35","30","wood","normal");
goods[22] =new setGoods("0000a68928","135","35","30","wood","normal");
goods[23] =new setGoods("0000a68935","140","35","30","wood","normal");
goods[24] =new setGoods("0000a68942","145","35","30","wood","normal");
goods[25] =new setGoods("0000a68949","150","35","30","wood","normal");
goods[26] =new setGoods("0000a57383","90","40","30","wood","normal");
goods[27] =new setGoods("0000a68956","95","40","30","wood","normal");
goods[28] =new setGoods("0000a68963","100","40","30","wood","normal");
goods[29] =new setGoods("0000a68970","105","40","30","wood","normal");
goods[30] =new setGoods("0000a68977","110","40","30","wood","normal");
goods[31] =new setGoods("0000a68984","115","40","30","wood","normal");
goods[32] =new setGoods("0000a68991","120","40","30","wood","normal");
goods[33] =new setGoods("0000a68998","125","40","30","wood","normal");
goods[34] =new setGoods("0000a69005","130","40","30","wood","normal");
goods[35] =new setGoods("0000a69012","135","40","30","wood","normal");
goods[36] =new setGoods("0000a69019","140","40","30","wood","normal");
goods[37] =new setGoods("0000a69026","145","40","30","wood","normal");
goods[38] =new setGoods("0000a69033","150","40","30","wood","normal");
goods[39] =new setGoods("0000a69040","90","45","30","wood","normal");
goods[40] =new setGoods("0000a69047","95","45","30","wood","normal");
goods[41] =new setGoods("0000a57390","100","45","30","wood","normal");
goods[42] =new setGoods("0000a69054","105","45","30","wood","normal");
goods[43] =new setGoods("0000a57397","110","45","30","wood","normal");
goods[44] =new setGoods("0000a69061","115","45","30","wood","normal");
goods[45] =new setGoods("0000a69068","120","45","30","wood","normal");
goods[46] =new setGoods("0000a69075","125","45","30","wood","normal");
goods[47] =new setGoods("0000a69082","130","45","30","wood","normal");
goods[48] =new setGoods("0000a69089","135","45","30","wood","normal");
goods[49] =new setGoods("0000a69096","140","45","30","wood","normal");
goods[50] =new setGoods("0000a69103","145","45","30","wood","normal");
goods[51] =new setGoods("0000a69110","150","45","30","wood","normal");
goods[52] =new setGoods("0000a69117","90","50","30","wood","normal");
goods[53] =new setGoods("0000a69124","95","50","30","wood","normal");
goods[54] =new setGoods("0000a69131","100","50","30","wood","normal");
goods[55] =new setGoods("0000a69138","105","50","30","wood","normal");
goods[56] =new setGoods("0000a69145","110","50","30","wood","normal");
goods[57] =new setGoods("0000a69152","115","50","30","wood","normal");
goods[58] =new setGoods("0000a57404","120","50","30","wood","normal");
goods[59] =new setGoods("0000a69159","125","50","30","wood","normal");
goods[60] =new setGoods("0000a69166","130","50","30","wood","normal");
goods[61] =new setGoods("0000a69173","135","50","30","wood","normal");
goods[62] =new setGoods("0000a69180","140","50","30","wood","normal");
goods[63] =new setGoods("0000a69187","145","50","30","wood","normal");
goods[64] =new setGoods("0000a69194","150","50","30","wood","normal");
goods[65] =new setGoods("0000a69201","90","55","30","wood","normal");
goods[66] =new setGoods("0000a69208","95","55","30","wood","normal");
goods[67] =new setGoods("0000a69215","100","55","30","wood","normal");
goods[68] =new setGoods("0000a69222","105","55","30","wood","normal");
goods[69] =new setGoods("0000a69229","110","55","30","wood","normal");
goods[70] =new setGoods("0000a69236","115","55","30","wood","normal");
goods[71] =new setGoods("0000a69243","120","55","30","wood","normal");
goods[72] =new setGoods("0000a69250","125","55","30","wood","normal");
goods[73] =new setGoods("0000a57411","130","55","30","wood","normal");
goods[74] =new setGoods("0000a69257","135","55","30","wood","normal");
goods[75] =new setGoods("0000a57418","140","55","30","wood","normal");
goods[76] =new setGoods("0000a69264","145","55","30","wood","normal");
goods[77] =new setGoods("0000a69271","150","55","30","wood","normal");
goods[78] =new setGoods("0000a69278","90","60","30","wood","normal");
goods[79] =new setGoods("0000a69285","95","60","30","wood","normal");
goods[80] =new setGoods("0000a69292","100","60","30","wood","normal");
goods[81] =new setGoods("0000a69299","105","60","30","wood","normal");
goods[82] =new setGoods("0000a69306","110","60","30","wood","normal");
goods[83] =new setGoods("0000a69313","115","60","30","wood","normal");
goods[84] =new setGoods("0000a69320","120","60","30","wood","normal");
goods[85] =new setGoods("0000a69327","125","60","30","wood","normal");
goods[86] =new setGoods("0000a69334","130","60","30","wood","normal");
goods[87] =new setGoods("0000a69341","135","60","30","wood","normal");
goods[88] =new setGoods("0000a69348","140","60","30","wood","normal");
goods[89] =new setGoods("0000a69355","145","60","30","wood","normal");
goods[90] =new setGoods("0000a57425","150","60","30","wood","normal");
goods[91] =new setGoods("0000a69362","90","30","42","wood","normal");
goods[92] =new setGoods("0000a69369","95","30","42","wood","normal");
goods[93] =new setGoods("0000a69376","100","30","42","wood","normal");
goods[94] =new setGoods("0000a69383","105","30","42","wood","normal");
goods[95] =new setGoods("0000a69390","110","30","42","wood","normal");
goods[96] =new setGoods("0000a69397","115","30","42","wood","normal");
goods[97] =new setGoods("0000a69404","120","30","42","wood","normal");
goods[98] =new setGoods("0000a69411","125","30","42","wood","normal");
goods[99] =new setGoods("0000a69418","130","30","42","wood","normal");
goods[100] =new setGoods("0000a69425","135","30","42","wood","normal");
goods[101] =new setGoods("0000a69432","140","30","42","wood","normal");
goods[102] =new setGoods("0000a69439","145","30","42","wood","normal");
goods[103] =new setGoods("0000a69446","150","30","42","wood","normal");
goods[104] =new setGoods("0000a69453","90","35","42","wood","normal");
goods[105] =new setGoods("0000a69460","95","35","42","wood","normal");
goods[106] =new setGoods("0000a69467","100","35","42","wood","normal");
goods[107] =new setGoods("0000a69474","105","35","42","wood","normal");
goods[108] =new setGoods("0000a69481","110","35","42","wood","normal");
goods[109] =new setGoods("0000a69488","115","35","42","wood","normal");
goods[110] =new setGoods("0000a69495","120","35","42","wood","normal");
goods[111] =new setGoods("0000a69502","125","35","42","wood","normal");
goods[112] =new setGoods("0000a69509","130","35","42","wood","normal");
goods[113] =new setGoods("0000a69516","135","35","42","wood","normal");
goods[114] =new setGoods("0000a69523","140","35","42","wood","normal");
goods[115] =new setGoods("0000a69530","145","35","42","wood","normal");
goods[116] =new setGoods("0000a69537","150","35","42","wood","normal");
goods[117] =new setGoods("0000a00049","90","40","42","wood","normal");
goods[118] =new setGoods("0000a69544","95","40","42","wood","normal");
goods[119] =new setGoods("0000a69551","100","40","42","wood","normal");
goods[120] =new setGoods("0000a69558","105","40","42","wood","normal");
goods[121] =new setGoods("0000a69565","110","40","42","wood","normal");
goods[122] =new setGoods("0000a69572","115","40","42","wood","normal");
goods[123] =new setGoods("0000a69579","120","40","42","wood","normal");
goods[124] =new setGoods("0000a69586","125","40","42","wood","normal");
goods[125] =new setGoods("0000a69593","130","40","42","wood","normal");
goods[126] =new setGoods("0000a69600","135","40","42","wood","normal");
goods[127] =new setGoods("0000a69607","140","40","42","wood","normal");
goods[128] =new setGoods("0000a69614","145","40","42","wood","normal");
goods[129] =new setGoods("0000a69621","150","40","42","wood","normal");
goods[130] =new setGoods("0000a69628","90","45","42","wood","normal");
goods[131] =new setGoods("0000a69635","95","45","42","wood","normal");
goods[132] =new setGoods("0000a57341","100","45","42","wood","normal");
goods[133] =new setGoods("0000a69642","105","45","42","wood","normal");
goods[134] =new setGoods("0000a57348","110","45","42","wood","normal");
goods[135] =new setGoods("0000a69649","115","45","42","wood","normal");
goods[136] =new setGoods("0000a69656","120","45","42","wood","normal");
goods[137] =new setGoods("0000a69663","125","45","42","wood","normal");
goods[138] =new setGoods("0000a69670","130","45","42","wood","normal");
goods[139] =new setGoods("0000a69677","135","45","42","wood","normal");
goods[140] =new setGoods("0000a69684","140","45","42","wood","normal");
goods[141] =new setGoods("0000a69691","145","45","42","wood","normal");
goods[142] =new setGoods("0000a69698","150","45","42","wood","normal");
goods[143] =new setGoods("0000a69705","90","50","42","wood","normal");
goods[144] =new setGoods("0000a69712","95","50","42","wood","normal");
goods[145] =new setGoods("0000a69719","100","50","42","wood","normal");
goods[146] =new setGoods("0000a69726","105","50","42","wood","normal");
goods[147] =new setGoods("0000a69733","110","50","42","wood","normal");
goods[148] =new setGoods("0000a69740","115","50","42","wood","normal");
goods[149] =new setGoods("0000a57355","120","50","42","wood","normal");
goods[150] =new setGoods("0000a69747","125","50","42","wood","normal");
goods[151] =new setGoods("0000a69754","130","50","42","wood","normal");
goods[152] =new setGoods("0000a69761","135","50","42","wood","normal");
goods[153] =new setGoods("0000a69768","140","50","42","wood","normal");
goods[154] =new setGoods("0000a69775","145","50","42","wood","normal");
goods[155] =new setGoods("0000a69782","150","50","42","wood","normal");
goods[156] =new setGoods("0000a69789","90","55","42","wood","normal");
goods[157] =new setGoods("0000a69796","95","55","42","wood","normal");
goods[158] =new setGoods("0000a69803","100","55","42","wood","normal");
goods[159] =new setGoods("0000a69810","105","55","42","wood","normal");
goods[160] =new setGoods("0000a69817","110","55","42","wood","normal");
goods[161] =new setGoods("0000a69824","115","55","42","wood","normal");
goods[162] =new setGoods("0000a69831","120","55","42","wood","normal");
goods[163] =new setGoods("0000a69838","125","55","42","wood","normal");
goods[164] =new setGoods("0000a57362","130","55","42","wood","normal");
goods[165] =new setGoods("0000a69845","135","55","42","wood","normal");
goods[166] =new setGoods("0000a57369","140","55","42","wood","normal");
goods[167] =new setGoods("0000a69852","145","55","42","wood","normal");
goods[168] =new setGoods("0000a69859","150","55","42","wood","normal");
goods[169] =new setGoods("0000a69866","90","60","42","wood","normal");
goods[170] =new setGoods("0000a69873","95","60","42","wood","normal");
goods[171] =new setGoods("0000a69880","100","60","42","wood","normal");
goods[172] =new setGoods("0000a69887","105","60","42","wood","normal");
goods[173] =new setGoods("0000a69894","110","60","42","wood","normal");
goods[174] =new setGoods("0000a69901","115","60","42","wood","normal");
goods[175] =new setGoods("0000a69908","120","60","42","wood","normal");
goods[176] =new setGoods("0000a69915","125","60","42","wood","normal");
goods[177] =new setGoods("0000a69922","130","60","42","wood","normal");
goods[178] =new setGoods("0000a69929","135","60","42","wood","normal");
goods[179] =new setGoods("0000a69936","140","60","42","wood","normal");
goods[180] =new setGoods("0000a69943","145","60","42","wood","normal");
goods[181] =new setGoods("0000a57376","150","60","42","wood","normal");
goods[182] =new setGoods("0000a69950","90","30","50","wood","normal");
goods[183] =new setGoods("0000a69957","95","30","50","wood","normal");
goods[184] =new setGoods("0000a69964","100","30","50","wood","normal");
goods[185] =new setGoods("0000a69971","105","30","50","wood","normal");
goods[186] =new setGoods("0000a69978","110","30","50","wood","normal");
goods[187] =new setGoods("0000a69985","115","30","50","wood","normal");
goods[188] =new setGoods("0000a69992","120","30","50","wood","normal");
goods[189] =new setGoods("0000a69999","125","30","50","wood","normal");
goods[190] =new setGoods("0000a70006","130","30","50","wood","normal");
goods[191] =new setGoods("0000a70013","135","30","50","wood","normal");
goods[192] =new setGoods("0000a70020","140","30","50","wood","normal");
goods[193] =new setGoods("0000a70027","145","30","50","wood","normal");
goods[194] =new setGoods("0000a70034","150","30","50","wood","normal");
goods[195] =new setGoods("0000a70041","90","35","50","wood","normal");
goods[196] =new setGoods("0000a70048","95","35","50","wood","normal");
goods[197] =new setGoods("0000a70055","100","35","50","wood","normal");
goods[198] =new setGoods("0000a70062","105","35","50","wood","normal");
goods[199] =new setGoods("0000a70069","110","35","50","wood","normal");
goods[200] =new setGoods("0000a70076","115","35","50","wood","normal");
goods[201] =new setGoods("0000a70083","120","35","50","wood","normal");
goods[202] =new setGoods("0000a70090","125","35","50","wood","normal");
goods[203] =new setGoods("0000a70097","130","35","50","wood","normal");
goods[204] =new setGoods("0000a70104","135","35","50","wood","normal");
goods[205] =new setGoods("0000a70111","140","35","50","wood","normal");
goods[206] =new setGoods("0000a70118","145","35","50","wood","normal");
goods[207] =new setGoods("0000a70125","150","35","50","wood","normal");
goods[208] =new setGoods("0000a70132","90","40","50","wood","normal");
goods[209] =new setGoods("0000a70139","95","40","50","wood","normal");
goods[210] =new setGoods("0000a70146","100","40","50","wood","normal");
goods[211] =new setGoods("0000a70153","105","40","50","wood","normal");
goods[212] =new setGoods("0000a70160","110","40","50","wood","normal");
goods[213] =new setGoods("0000a70167","115","40","50","wood","normal");
goods[214] =new setGoods("0000a70174","120","40","50","wood","normal");
goods[215] =new setGoods("0000a70181","125","40","50","wood","normal");
goods[216] =new setGoods("0000a70188","130","40","50","wood","normal");
goods[217] =new setGoods("0000a70195","135","40","50","wood","normal");
goods[218] =new setGoods("0000a70202","140","40","50","wood","normal");
goods[219] =new setGoods("0000a70209","145","40","50","wood","normal");
goods[220] =new setGoods("0000a70216","150","40","50","wood","normal");
goods[221] =new setGoods("0000a70223","90","45","50","wood","normal");
goods[222] =new setGoods("0000a70230","95","45","50","wood","normal");
goods[223] =new setGoods("0000a70237","100","45","50","wood","normal");
goods[224] =new setGoods("0000a70244","105","45","50","wood","normal");
goods[225] =new setGoods("0000a70251","110","45","50","wood","normal");
goods[226] =new setGoods("0000a70258","115","45","50","wood","normal");
goods[227] =new setGoods("0000a70265","120","45","50","wood","normal");
goods[228] =new setGoods("0000a70272","125","45","50","wood","normal");
goods[229] =new setGoods("0000a70279","130","45","50","wood","normal");
goods[230] =new setGoods("0000a70286","135","45","50","wood","normal");
goods[231] =new setGoods("0000a70293","140","45","50","wood","normal");
goods[232] =new setGoods("0000a70300","145","45","50","wood","normal");
goods[233] =new setGoods("0000a70307","150","45","50","wood","normal");
goods[234] =new setGoods("0000a70314","90","50","50","wood","normal");
goods[235] =new setGoods("0000a70321","95","50","50","wood","normal");
goods[236] =new setGoods("0000a70328","100","50","50","wood","normal");
goods[237] =new setGoods("0000a70335","105","50","50","wood","normal");
goods[238] =new setGoods("0000a70342","110","50","50","wood","normal");
goods[239] =new setGoods("0000a70349","115","50","50","wood","normal");
goods[240] =new setGoods("0000a70356","120","50","50","wood","normal");
goods[241] =new setGoods("0000a70363","125","50","50","wood","normal");
goods[242] =new setGoods("0000a70370","130","50","50","wood","normal");
goods[243] =new setGoods("0000a70377","135","50","50","wood","normal");
goods[244] =new setGoods("0000a70384","140","50","50","wood","normal");
goods[245] =new setGoods("0000a70391","145","50","50","wood","normal");
goods[246] =new setGoods("0000a70398","150","50","50","wood","normal");
goods[247] =new setGoods("0000a70405","90","55","50","wood","normal");
goods[248] =new setGoods("0000a70412","95","55","50","wood","normal");
goods[249] =new setGoods("0000a70419","100","55","50","wood","normal");
goods[250] =new setGoods("0000a70426","105","55","50","wood","normal");
goods[251] =new setGoods("0000a70433","110","55","50","wood","normal");
goods[252] =new setGoods("0000a70440","115","55","50","wood","normal");
goods[253] =new setGoods("0000a70447","120","55","50","wood","normal");
goods[254] =new setGoods("0000a70454","125","55","50","wood","normal");
goods[255] =new setGoods("0000a70461","130","55","50","wood","normal");
goods[256] =new setGoods("0000a70468","135","55","50","wood","normal");
goods[257] =new setGoods("0000a70475","140","55","50","wood","normal");
goods[258] =new setGoods("0000a70482","145","55","50","wood","normal");
goods[259] =new setGoods("0000a70489","150","55","50","wood","normal");
goods[260] =new setGoods("0000a70496","90","60","50","wood","normal");
goods[261] =new setGoods("0000a70503","95","60","50","wood","normal");
goods[262] =new setGoods("0000a70510","100","60","50","wood","normal");
goods[263] =new setGoods("0000a70517","105","60","50","wood","normal");
goods[264] =new setGoods("0000a70524","110","60","50","wood","normal");
goods[265] =new setGoods("0000a70531","115","60","50","wood","normal");
goods[266] =new setGoods("0000a70538","120","60","50","wood","normal");
goods[267] =new setGoods("0000a70545","125","60","50","wood","normal");
goods[268] =new setGoods("0000a70552","130","60","50","wood","normal");
goods[269] =new setGoods("0000a70559","135","60","50","wood","normal");
goods[270] =new setGoods("0000a70566","140","60","50","wood","normal");
goods[271] =new setGoods("0000a70573","145","60","50","wood","normal");
goods[272] =new setGoods("0000a70580","150","60","50","wood","normal");
goods[273] =new setGoods("0000a79989","90","30","30","aino","normal");
goods[274] =new setGoods("0000a79995","95","30","30","aino","normal");
goods[275] =new setGoods("0000a80001","100","30","30","aino","normal");
goods[276] =new setGoods("0000a80007","105","30","30","aino","normal");
goods[277] =new setGoods("0000a80013","110","30","30","aino","normal");
goods[278] =new setGoods("0000a80019","115","30","30","aino","normal");
goods[279] =new setGoods("0000a80025","120","30","30","aino","normal");
goods[280] =new setGoods("0000a80031","125","30","30","aino","normal");
goods[281] =new setGoods("0000a80037","130","30","30","aino","normal");
goods[282] =new setGoods("0000a80043","135","30","30","aino","normal");
goods[283] =new setGoods("0000a80049","140","30","30","aino","normal");
goods[284] =new setGoods("0000a80055","145","30","30","aino","normal");
goods[285] =new setGoods("0000a80061","150","30","30","aino","normal");
goods[286] =new setGoods("0000a80067","90","35","30","aino","normal");
goods[287] =new setGoods("0000a80073","95","35","30","aino","normal");
goods[288] =new setGoods("0000a80079","100","35","30","aino","normal");
goods[289] =new setGoods("0000a80085","105","35","30","aino","normal");
goods[290] =new setGoods("0000a80091","110","35","30","aino","normal");
goods[291] =new setGoods("0000a80097","115","35","30","aino","normal");
goods[292] =new setGoods("0000a80103","120","35","30","aino","normal");
goods[293] =new setGoods("0000a80109","125","35","30","aino","normal");
goods[294] =new setGoods("0000a80115","130","35","30","aino","normal");
goods[295] =new setGoods("0000a80121","135","35","30","aino","normal");
goods[296] =new setGoods("0000a80127","140","35","30","aino","normal");
goods[297] =new setGoods("0000a80133","145","35","30","aino","normal");
goods[298] =new setGoods("0000a80139","150","35","30","aino","normal");
goods[299] =new setGoods("0000a80145","90","40","30","aino","normal");
goods[300] =new setGoods("0000a80151","95","40","30","aino","normal");
goods[301] =new setGoods("0000a80157","100","40","30","aino","normal");
goods[302] =new setGoods("0000a80163","105","40","30","aino","normal");
goods[303] =new setGoods("0000a80169","110","40","30","aino","normal");
goods[304] =new setGoods("0000a80175","115","40","30","aino","normal");
goods[305] =new setGoods("0000a80181","120","40","30","aino","normal");
goods[306] =new setGoods("0000a80187","125","40","30","aino","normal");
goods[307] =new setGoods("0000a80193","130","40","30","aino","normal");
goods[308] =new setGoods("0000a80199","135","40","30","aino","normal");
goods[309] =new setGoods("0000a80205","140","40","30","aino","normal");
goods[310] =new setGoods("0000a80211","145","40","30","aino","normal");
goods[311] =new setGoods("0000a80217","150","40","30","aino","normal");
goods[312] =new setGoods("0000a80223","90","45","30","aino","normal");
goods[313] =new setGoods("0000a80229","95","45","30","aino","normal");
goods[314] =new setGoods("0000a80235","100","45","30","aino","normal");
goods[315] =new setGoods("0000a80241","105","45","30","aino","normal");
goods[316] =new setGoods("0000a80247","110","45","30","aino","normal");
goods[317] =new setGoods("0000a80253","115","45","30","aino","normal");
goods[318] =new setGoods("0000a80259","120","45","30","aino","normal");
goods[319] =new setGoods("0000a80265","125","45","30","aino","normal");
goods[320] =new setGoods("0000a80271","130","45","30","aino","normal");
goods[321] =new setGoods("0000a80277","135","45","30","aino","normal");
goods[322] =new setGoods("0000a80283","140","45","30","aino","normal");
goods[323] =new setGoods("0000a80289","145","45","30","aino","normal");
goods[324] =new setGoods("0000a80295","150","45","30","aino","normal");
goods[325] =new setGoods("0000a80301","90","50","30","aino","normal");
goods[326] =new setGoods("0000a80307","95","50","30","aino","normal");
goods[327] =new setGoods("0000a80313","100","50","30","aino","normal");
goods[328] =new setGoods("0000a80319","105","50","30","aino","normal");
goods[329] =new setGoods("0000a80325","110","50","30","aino","normal");
goods[330] =new setGoods("0000a80331","115","50","30","aino","normal");
goods[331] =new setGoods("0000a80337","120","50","30","aino","normal");
goods[332] =new setGoods("0000a80343","125","50","30","aino","normal");
goods[333] =new setGoods("0000a80349","130","50","30","aino","normal");
goods[334] =new setGoods("0000a80355","135","50","30","aino","normal");
goods[335] =new setGoods("0000a80361","140","50","30","aino","normal");
goods[336] =new setGoods("0000a80367","145","50","30","aino","normal");
goods[337] =new setGoods("0000a80373","150","50","30","aino","normal");
goods[338] =new setGoods("0000a80379","90","55","30","aino","normal");
goods[339] =new setGoods("0000a80385","95","55","30","aino","normal");
goods[340] =new setGoods("0000a80391","100","55","30","aino","normal");
goods[341] =new setGoods("0000a80397","105","55","30","aino","normal");
goods[342] =new setGoods("0000a80403","110","55","30","aino","normal");
goods[343] =new setGoods("0000a80409","115","55","30","aino","normal");
goods[344] =new setGoods("0000a80415","120","55","30","aino","normal");
goods[345] =new setGoods("0000a80421","125","55","30","aino","normal");
goods[346] =new setGoods("0000a80427","130","55","30","aino","normal");
goods[347] =new setGoods("0000a80433","135","55","30","aino","normal");
goods[348] =new setGoods("0000a80439","140","55","30","aino","normal");
goods[349] =new setGoods("0000a80445","145","55","30","aino","normal");
goods[350] =new setGoods("0000a80451","150","55","30","aino","normal");
goods[351] =new setGoods("0000a80457","90","60","30","aino","normal");
goods[352] =new setGoods("0000a80463","95","60","30","aino","normal");
goods[353] =new setGoods("0000a80469","100","60","30","aino","normal");
goods[354] =new setGoods("0000a80475","105","60","30","aino","normal");
goods[355] =new setGoods("0000a80481","110","60","30","aino","normal");
goods[356] =new setGoods("0000a80487","115","60","30","aino","normal");
goods[357] =new setGoods("0000a80493","120","60","30","aino","normal");
goods[358] =new setGoods("0000a80499","125","60","30","aino","normal");
goods[359] =new setGoods("0000a80505","130","60","30","aino","normal");
goods[360] =new setGoods("0000a80511","135","60","30","aino","normal");
goods[361] =new setGoods("0000a80517","140","60","30","aino","normal");
goods[362] =new setGoods("0000a80523","145","60","30","aino","normal");
goods[363] =new setGoods("0000a80529","150","60","30","aino","normal");
goods[364] =new setGoods("0000a80535","90","30","42","aino","normal");
goods[365] =new setGoods("0000a80541","95","30","42","aino","normal");
goods[366] =new setGoods("0000a80547","100","30","42","aino","normal");
goods[367] =new setGoods("0000a80553","105","30","42","aino","normal");
goods[368] =new setGoods("0000a80559","110","30","42","aino","normal");
goods[369] =new setGoods("0000a80565","115","30","42","aino","normal");
goods[370] =new setGoods("0000a80571","120","30","42","aino","normal");
goods[371] =new setGoods("0000a80577","125","30","42","aino","normal");
goods[372] =new setGoods("0000a80583","130","30","42","aino","normal");
goods[373] =new setGoods("0000a80589","135","30","42","aino","normal");
goods[374] =new setGoods("0000a80595","140","30","42","aino","normal");
goods[375] =new setGoods("0000a80601","145","30","42","aino","normal");
goods[376] =new setGoods("0000a80607","150","30","42","aino","normal");
goods[377] =new setGoods("0000a80613","90","35","42","aino","normal");
goods[378] =new setGoods("0000a80619","95","35","42","aino","normal");
goods[379] =new setGoods("0000a80625","100","35","42","aino","normal");
goods[380] =new setGoods("0000a80631","105","35","42","aino","normal");
goods[381] =new setGoods("0000a80637","110","35","42","aino","normal");
goods[382] =new setGoods("0000a80643","115","35","42","aino","normal");
goods[383] =new setGoods("0000a80649","120","35","42","aino","normal");
goods[384] =new setGoods("0000a80655","125","35","42","aino","normal");
goods[385] =new setGoods("0000a80661","130","35","42","aino","normal");
goods[386] =new setGoods("0000a80667","135","35","42","aino","normal");
goods[387] =new setGoods("0000a80673","140","35","42","aino","normal");
goods[388] =new setGoods("0000a80679","145","35","42","aino","normal");
goods[389] =new setGoods("0000a80685","150","35","42","aino","normal");
goods[390] =new setGoods("0000a39218","90","40","42","aino","normal");
goods[391] =new setGoods("0000a80691","95","40","42","aino","normal");
goods[392] =new setGoods("0000a80697","100","40","42","aino","normal");
goods[393] =new setGoods("0000a80703","105","40","42","aino","normal");
goods[394] =new setGoods("0000a80709","110","40","42","aino","normal");
goods[395] =new setGoods("0000a80715","115","40","42","aino","normal");
goods[396] =new setGoods("0000a80721","120","40","42","aino","normal");
goods[397] =new setGoods("0000a80727","125","40","42","aino","normal");
goods[398] =new setGoods("0000a80733","130","40","42","aino","normal");
goods[399] =new setGoods("0000a80739","135","40","42","aino","normal");
goods[400] =new setGoods("0000a80745","140","40","42","aino","normal");
goods[401] =new setGoods("0000a80751","145","40","42","aino","normal");
goods[402] =new setGoods("0000a80757","150","40","42","aino","normal");
goods[403] =new setGoods("0000a80763","90","45","42","aino","normal");
goods[404] =new setGoods("0000a80769","95","45","42","aino","normal");
goods[405] =new setGoods("0000a80775","100","45","42","aino","normal");
goods[406] =new setGoods("0000a80781","105","45","42","aino","normal");
goods[407] =new setGoods("0000a80787","110","45","42","aino","normal");
goods[408] =new setGoods("0000a80793","115","45","42","aino","normal");
goods[409] =new setGoods("0000a80799","120","45","42","aino","normal");
goods[410] =new setGoods("0000a80805","125","45","42","aino","normal");
goods[411] =new setGoods("0000a80811","130","45","42","aino","normal");
goods[412] =new setGoods("0000a80817","135","45","42","aino","normal");
goods[413] =new setGoods("0000a80823","140","45","42","aino","normal");
goods[414] =new setGoods("0000a80829","145","45","42","aino","normal");
goods[415] =new setGoods("0000a80835","150","45","42","aino","normal");
goods[416] =new setGoods("0000a80841","90","50","42","aino","normal");
goods[417] =new setGoods("0000a80847","95","50","42","aino","normal");
goods[418] =new setGoods("0000a80853","100","50","42","aino","normal");
goods[419] =new setGoods("0000a80859","105","50","42","aino","normal");
goods[420] =new setGoods("0000a80865","110","50","42","aino","normal");
goods[421] =new setGoods("0000a80871","115","50","42","aino","normal");
goods[422] =new setGoods("0000a80877","120","50","42","aino","normal");
goods[423] =new setGoods("0000a80883","125","50","42","aino","normal");
goods[424] =new setGoods("0000a80889","130","50","42","aino","normal");
goods[425] =new setGoods("0000a80895","135","50","42","aino","normal");
goods[426] =new setGoods("0000a80901","140","50","42","aino","normal");
goods[427] =new setGoods("0000a80907","145","50","42","aino","normal");
goods[428] =new setGoods("0000a80913","150","50","42","aino","normal");
goods[429] =new setGoods("0000a80919","90","55","42","aino","normal");
goods[430] =new setGoods("0000a80925","95","55","42","aino","normal");
goods[431] =new setGoods("0000a80931","100","55","42","aino","normal");
goods[432] =new setGoods("0000a80937","105","55","42","aino","normal");
goods[433] =new setGoods("0000a80943","110","55","42","aino","normal");
goods[434] =new setGoods("0000a80949","115","55","42","aino","normal");
goods[435] =new setGoods("0000a80955","120","55","42","aino","normal");
goods[436] =new setGoods("0000a80961","125","55","42","aino","normal");
goods[437] =new setGoods("0000a80967","130","55","42","aino","normal");
goods[438] =new setGoods("0000a80973","135","55","42","aino","normal");
goods[439] =new setGoods("0000a80979","140","55","42","aino","normal");
goods[440] =new setGoods("0000a80985","145","55","42","aino","normal");
goods[441] =new setGoods("0000a80991","150","55","42","aino","normal");
goods[442] =new setGoods("0000a80997","90","60","42","aino","normal");
goods[443] =new setGoods("0000a81003","95","60","42","aino","normal");
goods[444] =new setGoods("0000a81009","100","60","42","aino","normal");
goods[445] =new setGoods("0000a81015","105","60","42","aino","normal");
goods[446] =new setGoods("0000a81021","110","60","42","aino","normal");
goods[447] =new setGoods("0000a81027","115","60","42","aino","normal");
goods[448] =new setGoods("0000a81033","120","60","42","aino","normal");
goods[449] =new setGoods("0000a81039","125","60","42","aino","normal");
goods[450] =new setGoods("0000a81045","130","60","42","aino","normal");
goods[451] =new setGoods("0000a81051","135","60","42","aino","normal");
goods[452] =new setGoods("0000a81057","140","60","42","aino","normal");
goods[453] =new setGoods("0000a81063","145","60","42","aino","normal");
goods[454] =new setGoods("0000a81069","150","60","42","aino","normal");
goods[455] =new setGoods("0000a81075","90","30","50","aino","normal");
goods[456] =new setGoods("0000a81081","95","30","50","aino","normal");
goods[457] =new setGoods("0000a81087","100","30","50","aino","normal");
goods[458] =new setGoods("0000a81093","105","30","50","aino","normal");
goods[459] =new setGoods("0000a81099","110","30","50","aino","normal");
goods[460] =new setGoods("0000a81105","115","30","50","aino","normal");
goods[461] =new setGoods("0000a81111","120","30","50","aino","normal");
goods[462] =new setGoods("0000a81117","125","30","50","aino","normal");
goods[463] =new setGoods("0000a81123","130","30","50","aino","normal");
goods[464] =new setGoods("0000a81129","135","30","50","aino","normal");
goods[465] =new setGoods("0000a81135","140","30","50","aino","normal");
goods[466] =new setGoods("0000a81141","145","30","50","aino","normal");
goods[467] =new setGoods("0000a81147","150","30","50","aino","normal");
goods[468] =new setGoods("0000a81153","90","35","50","aino","normal");
goods[469] =new setGoods("0000a81159","95","35","50","aino","normal");
goods[470] =new setGoods("0000a81165","100","35","50","aino","normal");
goods[471] =new setGoods("0000a81171","105","35","50","aino","normal");
goods[472] =new setGoods("0000a81177","110","35","50","aino","normal");
goods[473] =new setGoods("0000a81183","115","35","50","aino","normal");
goods[474] =new setGoods("0000a81189","120","35","50","aino","normal");
goods[475] =new setGoods("0000a81195","125","35","50","aino","normal");
goods[476] =new setGoods("0000a81201","130","35","50","aino","normal");
goods[477] =new setGoods("0000a81207","135","35","50","aino","normal");
goods[478] =new setGoods("0000a81213","140","35","50","aino","normal");
goods[479] =new setGoods("0000a81219","145","35","50","aino","normal");
goods[480] =new setGoods("0000a81225","150","35","50","aino","normal");
goods[481] =new setGoods("0000a81231","90","40","50","aino","normal");
goods[482] =new setGoods("0000a81237","95","40","50","aino","normal");
goods[483] =new setGoods("0000a81243","100","40","50","aino","normal");
goods[484] =new setGoods("0000a81249","105","40","50","aino","normal");
goods[485] =new setGoods("0000a81255","110","40","50","aino","normal");
goods[486] =new setGoods("0000a81261","115","40","50","aino","normal");
goods[487] =new setGoods("0000a81267","120","40","50","aino","normal");
goods[488] =new setGoods("0000a81273","125","40","50","aino","normal");
goods[489] =new setGoods("0000a81279","130","40","50","aino","normal");
goods[490] =new setGoods("0000a81285","135","40","50","aino","normal");
goods[491] =new setGoods("0000a81291","140","40","50","aino","normal");
goods[492] =new setGoods("0000a81297","145","40","50","aino","normal");
goods[493] =new setGoods("0000a81303","150","40","50","aino","normal");
goods[494] =new setGoods("0000a81309","90","45","50","aino","normal");
goods[495] =new setGoods("0000a81315","95","45","50","aino","normal");
goods[496] =new setGoods("0000a81321","100","45","50","aino","normal");
goods[497] =new setGoods("0000a81327","105","45","50","aino","normal");
goods[498] =new setGoods("0000a81333","110","45","50","aino","normal");
goods[499] =new setGoods("0000a81339","115","45","50","aino","normal");
goods[500] =new setGoods("0000a81345","120","45","50","aino","normal");
goods[501] =new setGoods("0000a81351","125","45","50","aino","normal");
goods[502] =new setGoods("0000a81357","130","45","50","aino","normal");
goods[503] =new setGoods("0000a81363","135","45","50","aino","normal");
goods[504] =new setGoods("0000a81369","140","45","50","aino","normal");
goods[505] =new setGoods("0000a81375","145","45","50","aino","normal");
goods[506] =new setGoods("0000a81381","150","45","50","aino","normal");
goods[507] =new setGoods("0000a81387","90","50","50","aino","normal");
goods[508] =new setGoods("0000a81393","95","50","50","aino","normal");
goods[509] =new setGoods("0000a81399","100","50","50","aino","normal");
goods[510] =new setGoods("0000a81405","105","50","50","aino","normal");
goods[511] =new setGoods("0000a81411","110","50","50","aino","normal");
goods[512] =new setGoods("0000a81417","115","50","50","aino","normal");
goods[513] =new setGoods("0000a81423","120","50","50","aino","normal");
goods[514] =new setGoods("0000a81429","125","50","50","aino","normal");
goods[515] =new setGoods("0000a81435","130","50","50","aino","normal");
goods[516] =new setGoods("0000a81441","135","50","50","aino","normal");
goods[517] =new setGoods("0000a81447","140","50","50","aino","normal");
goods[518] =new setGoods("0000a81453","145","50","50","aino","normal");
goods[519] =new setGoods("0000a81459","150","50","50","aino","normal");
goods[520] =new setGoods("0000a81465","90","55","50","aino","normal");
goods[521] =new setGoods("0000a81471","95","55","50","aino","normal");
goods[522] =new setGoods("0000a81477","100","55","50","aino","normal");
goods[523] =new setGoods("0000a81483","105","55","50","aino","normal");
goods[524] =new setGoods("0000a81489","110","55","50","aino","normal");
goods[525] =new setGoods("0000a81495","115","55","50","aino","normal");
goods[526] =new setGoods("0000a81501","120","55","50","aino","normal");
goods[527] =new setGoods("0000a81507","125","55","50","aino","normal");
goods[528] =new setGoods("0000a81513","130","55","50","aino","normal");
goods[529] =new setGoods("0000a81519","135","55","50","aino","normal");
goods[530] =new setGoods("0000a81525","140","55","50","aino","normal");
goods[531] =new setGoods("0000a81531","145","55","50","aino","normal");
goods[532] =new setGoods("0000a81537","150","55","50","aino","normal");
goods[533] =new setGoods("0000a81543","90","60","50","aino","normal");
goods[534] =new setGoods("0000a81549","95","60","50","aino","normal");
goods[535] =new setGoods("0000a81555","100","60","50","aino","normal");
goods[536] =new setGoods("0000a81561","105","60","50","aino","normal");
goods[537] =new setGoods("0000a81567","110","60","50","aino","normal");
goods[538] =new setGoods("0000a81573","115","60","50","aino","normal");
goods[539] =new setGoods("0000a81579","120","60","50","aino","normal");
goods[540] =new setGoods("0000a81585","125","60","50","aino","normal");
goods[541] =new setGoods("0000a81591","130","60","50","aino","normal");
goods[542] =new setGoods("0000a81597","135","60","50","aino","normal");
goods[543] =new setGoods("0000a81603","140","60","50","aino","normal");
goods[544] =new setGoods("0000a81609","145","60","50","aino","normal");
goods[545] =new setGoods("0000a81615","150","60","50","aino","normal");
goods[546] =new setGoods("0000a81635","90","30","30","nail","normal");
goods[547] =new setGoods("0000a81636","95","30","30","nail","normal");
goods[548] =new setGoods("0000a81637","100","30","30","nail","normal");
goods[549] =new setGoods("0000a81638","105","30","30","nail","normal");
goods[550] =new setGoods("0000a81639","110","30","30","nail","normal");
goods[551] =new setGoods("0000a81640","115","30","30","nail","normal");
goods[552] =new setGoods("0000a81641","120","30","30","nail","normal");
goods[553] =new setGoods("0000a81642","125","30","30","nail","normal");
goods[554] =new setGoods("0000a81643","130","30","30","nail","normal");
goods[555] =new setGoods("0000a81644","135","30","30","nail","normal");
goods[556] =new setGoods("0000a81645","140","30","30","nail","normal");
goods[557] =new setGoods("0000a81646","145","30","30","nail","normal");
goods[558] =new setGoods("0000a81647","150","30","30","nail","normal");
goods[559] =new setGoods("0000a81648","90","35","30","nail","normal");
goods[560] =new setGoods("0000a81649","95","35","30","nail","normal");
goods[561] =new setGoods("0000a81650","100","35","30","nail","normal");
goods[562] =new setGoods("0000a81651","105","35","30","nail","normal");
goods[563] =new setGoods("0000a81652","110","35","30","nail","normal");
goods[564] =new setGoods("0000a81653","115","35","30","nail","normal");
goods[565] =new setGoods("0000a81654","120","35","30","nail","normal");
goods[566] =new setGoods("0000a81655","125","35","30","nail","normal");
goods[567] =new setGoods("0000a81656","130","35","30","nail","normal");
goods[568] =new setGoods("0000a81657","135","35","30","nail","normal");
goods[569] =new setGoods("0000a81658","140","35","30","nail","normal");
goods[570] =new setGoods("0000a81659","145","35","30","nail","normal");
goods[571] =new setGoods("0000a81660","150","35","30","nail","normal");
goods[572] =new setGoods("0000a81661","90","40","30","nail","normal");
goods[573] =new setGoods("0000a81662","95","40","30","nail","normal");
goods[574] =new setGoods("0000a81663","100","40","30","nail","normal");
goods[575] =new setGoods("0000a81664","105","40","30","nail","normal");
goods[576] =new setGoods("0000a81665","110","40","30","nail","normal");
goods[577] =new setGoods("0000a81666","115","40","30","nail","normal");
goods[578] =new setGoods("0000a81667","120","40","30","nail","normal");
goods[579] =new setGoods("0000a81668","125","40","30","nail","normal");
goods[580] =new setGoods("0000a81669","130","40","30","nail","normal");
goods[581] =new setGoods("0000a81670","135","40","30","nail","normal");
goods[582] =new setGoods("0000a81671","140","40","30","nail","normal");
goods[583] =new setGoods("0000a81672","145","40","30","nail","normal");
goods[584] =new setGoods("0000a81673","150","40","30","nail","normal");
goods[585] =new setGoods("0000a81674","90","45","30","nail","normal");
goods[586] =new setGoods("0000a81675","95","45","30","nail","normal");
goods[587] =new setGoods("0000a81676","100","45","30","nail","normal");
goods[588] =new setGoods("0000a81677","105","45","30","nail","normal");
goods[589] =new setGoods("0000a81678","110","45","30","nail","normal");
goods[590] =new setGoods("0000a81679","115","45","30","nail","normal");
goods[591] =new setGoods("0000a81680","120","45","30","nail","normal");
goods[592] =new setGoods("0000a81681","125","45","30","nail","normal");
goods[593] =new setGoods("0000a81682","130","45","30","nail","normal");
goods[594] =new setGoods("0000a81683","135","45","30","nail","normal");
goods[595] =new setGoods("0000a81684","140","45","30","nail","normal");
goods[596] =new setGoods("0000a81685","145","45","30","nail","normal");
goods[597] =new setGoods("0000a81686","150","45","30","nail","normal");
goods[598] =new setGoods("0000a81687","90","50","30","nail","normal");
goods[599] =new setGoods("0000a81688","95","50","30","nail","normal");
goods[600] =new setGoods("0000a81689","100","50","30","nail","normal");
goods[601] =new setGoods("0000a81690","105","50","30","nail","normal");
goods[602] =new setGoods("0000a81691","110","50","30","nail","normal");
goods[603] =new setGoods("0000a81692","115","50","30","nail","normal");
goods[604] =new setGoods("0000a81693","120","50","30","nail","normal");
goods[605] =new setGoods("0000a81694","125","50","30","nail","normal");
goods[606] =new setGoods("0000a81695","130","50","30","nail","normal");
goods[607] =new setGoods("0000a81696","135","50","30","nail","normal");
goods[608] =new setGoods("0000a81697","140","50","30","nail","normal");
goods[609] =new setGoods("0000a81698","145","50","30","nail","normal");
goods[610] =new setGoods("0000a81699","150","50","30","nail","normal");
goods[611] =new setGoods("0000a81700","90","55","30","nail","normal");
goods[612] =new setGoods("0000a81701","95","55","30","nail","normal");
goods[613] =new setGoods("0000a81702","100","55","30","nail","normal");
goods[614] =new setGoods("0000a81703","105","55","30","nail","normal");
goods[615] =new setGoods("0000a81704","110","55","30","nail","normal");
goods[616] =new setGoods("0000a81705","115","55","30","nail","normal");
goods[617] =new setGoods("0000a81706","120","55","30","nail","normal");
goods[618] =new setGoods("0000a81707","125","55","30","nail","normal");
goods[619] =new setGoods("0000a81708","130","55","30","nail","normal");
goods[620] =new setGoods("0000a81709","135","55","30","nail","normal");
goods[621] =new setGoods("0000a81710","140","55","30","nail","normal");
goods[622] =new setGoods("0000a81711","145","55","30","nail","normal");
goods[623] =new setGoods("0000a81712","150","55","30","nail","normal");
goods[624] =new setGoods("0000a81713","90","60","30","nail","normal");
goods[625] =new setGoods("0000a81714","95","60","30","nail","normal");
goods[626] =new setGoods("0000a81715","100","60","30","nail","normal");
goods[627] =new setGoods("0000a81716","105","60","30","nail","normal");
goods[628] =new setGoods("0000a81717","110","60","30","nail","normal");
goods[629] =new setGoods("0000a81718","115","60","30","nail","normal");
goods[630] =new setGoods("0000a81719","120","60","30","nail","normal");
goods[631] =new setGoods("0000a81720","125","60","30","nail","normal");
goods[632] =new setGoods("0000a81721","130","60","30","nail","normal");
goods[633] =new setGoods("0000a81722","135","60","30","nail","normal");
goods[634] =new setGoods("0000a81723","140","60","30","nail","normal");
goods[635] =new setGoods("0000a81724","145","60","30","nail","normal");
goods[636] =new setGoods("0000a81725","150","60","30","nail","normal");
goods[637] =new setGoods("0000a81726","90","30","42","nail","normal");
goods[638] =new setGoods("0000a81727","95","30","42","nail","normal");
goods[639] =new setGoods("0000a81728","100","30","42","nail","normal");
goods[640] =new setGoods("0000a81729","105","30","42","nail","normal");
goods[641] =new setGoods("0000a81730","110","30","42","nail","normal");
goods[642] =new setGoods("0000a81731","115","30","42","nail","normal");
goods[643] =new setGoods("0000a81732","120","30","42","nail","normal");
goods[644] =new setGoods("0000a81733","125","30","42","nail","normal");
goods[645] =new setGoods("0000a81734","130","30","42","nail","normal");
goods[646] =new setGoods("0000a81735","135","30","42","nail","normal");
goods[647] =new setGoods("0000a81736","140","30","42","nail","normal");
goods[648] =new setGoods("0000a81737","145","30","42","nail","normal");
goods[649] =new setGoods("0000a81738","150","30","42","nail","normal");
goods[650] =new setGoods("0000a81739","90","35","42","nail","normal");
goods[651] =new setGoods("0000a81740","95","35","42","nail","normal");
goods[652] =new setGoods("0000a81741","100","35","42","nail","normal");
goods[653] =new setGoods("0000a81742","105","35","42","nail","normal");
goods[654] =new setGoods("0000a81743","110","35","42","nail","normal");
goods[655] =new setGoods("0000a81744","115","35","42","nail","normal");
goods[656] =new setGoods("0000a81745","120","35","42","nail","normal");
goods[657] =new setGoods("0000a81746","125","35","42","nail","normal");
goods[658] =new setGoods("0000a81747","130","35","42","nail","normal");
goods[659] =new setGoods("0000a81748","135","35","42","nail","normal");
goods[660] =new setGoods("0000a81749","140","35","42","nail","normal");
goods[661] =new setGoods("0000a81750","145","35","42","nail","normal");
goods[662] =new setGoods("0000a81751","150","35","42","nail","normal");
goods[663] =new setGoods("0000a81752","90","40","42","nail","normal");
goods[664] =new setGoods("0000a81753","95","40","42","nail","normal");
goods[665] =new setGoods("0000a81754","100","40","42","nail","normal");
goods[666] =new setGoods("0000a81755","105","40","42","nail","normal");
goods[667] =new setGoods("0000a81756","110","40","42","nail","normal");
goods[668] =new setGoods("0000a81757","115","40","42","nail","normal");
goods[669] =new setGoods("0000a81758","120","40","42","nail","normal");
goods[670] =new setGoods("0000a81759","125","40","42","nail","normal");
goods[671] =new setGoods("0000a81760","130","40","42","nail","normal");
goods[672] =new setGoods("0000a81761","135","40","42","nail","normal");
goods[673] =new setGoods("0000a81762","140","40","42","nail","normal");
goods[674] =new setGoods("0000a81763","145","40","42","nail","normal");
goods[675] =new setGoods("0000a81764","150","40","42","nail","normal");
goods[676] =new setGoods("0000a81765","90","45","42","nail","normal");
goods[677] =new setGoods("0000a81766","95","45","42","nail","normal");
goods[678] =new setGoods("0000a81767","100","45","42","nail","normal");
goods[679] =new setGoods("0000a81768","105","45","42","nail","normal");
goods[680] =new setGoods("0000a81769","110","45","42","nail","normal");
goods[681] =new setGoods("0000a81770","115","45","42","nail","normal");
goods[682] =new setGoods("0000a81771","120","45","42","nail","normal");
goods[683] =new setGoods("0000a81772","125","45","42","nail","normal");
goods[684] =new setGoods("0000a81773","130","45","42","nail","normal");
goods[685] =new setGoods("0000a81774","135","45","42","nail","normal");
goods[686] =new setGoods("0000a81775","140","45","42","nail","normal");
goods[687] =new setGoods("0000a81776","145","45","42","nail","normal");
goods[688] =new setGoods("0000a81777","150","45","42","nail","normal");
goods[689] =new setGoods("0000a81778","90","50","42","nail","normal");
goods[690] =new setGoods("0000a81779","95","50","42","nail","normal");
goods[691] =new setGoods("0000a81780","100","50","42","nail","normal");
goods[692] =new setGoods("0000a81781","105","50","42","nail","normal");
goods[693] =new setGoods("0000a81782","110","50","42","nail","normal");
goods[694] =new setGoods("0000a81783","115","50","42","nail","normal");
goods[695] =new setGoods("0000a81784","120","50","42","nail","normal");
goods[696] =new setGoods("0000a81785","125","50","42","nail","normal");
goods[697] =new setGoods("0000a81786","130","50","42","nail","normal");
goods[698] =new setGoods("0000a81787","135","50","42","nail","normal");
goods[699] =new setGoods("0000a81788","140","50","42","nail","normal");
goods[700] =new setGoods("0000a81789","145","50","42","nail","normal");
goods[701] =new setGoods("0000a81790","150","50","42","nail","normal");
goods[702] =new setGoods("0000a81791","90","55","42","nail","normal");
goods[703] =new setGoods("0000a81792","95","55","42","nail","normal");
goods[704] =new setGoods("0000a81793","100","55","42","nail","normal");
goods[705] =new setGoods("0000a81794","105","55","42","nail","normal");
goods[706] =new setGoods("0000a09426","110","55","42","nail","normal");
goods[707] =new setGoods("0000a81795","115","55","42","nail","normal");
goods[708] =new setGoods("0000a81796","120","55","42","nail","normal");
goods[709] =new setGoods("0000a81797","125","55","42","nail","normal");
goods[710] =new setGoods("0000a81798","130","55","42","nail","normal");
goods[711] =new setGoods("0000a81799","135","55","42","nail","normal");
goods[712] =new setGoods("0000a81800","140","55","42","nail","normal");
goods[713] =new setGoods("0000a81801","145","55","42","nail","normal");
goods[714] =new setGoods("0000a81802","150","55","42","nail","normal");
goods[715] =new setGoods("0000a81803","90","60","42","nail","normal");
goods[716] =new setGoods("0000a81804","95","60","42","nail","normal");
goods[717] =new setGoods("0000a81805","100","60","42","nail","normal");
goods[718] =new setGoods("0000a81806","105","60","42","nail","normal");
goods[719] =new setGoods("0000a81807","110","60","42","nail","normal");
goods[720] =new setGoods("0000a81808","115","60","42","nail","normal");
goods[721] =new setGoods("0000a81809","120","60","42","nail","normal");
goods[722] =new setGoods("0000a81810","125","60","42","nail","normal");
goods[723] =new setGoods("0000a81811","130","60","42","nail","normal");
goods[724] =new setGoods("0000a81812","135","60","42","nail","normal");
goods[725] =new setGoods("0000a81813","140","60","42","nail","normal");
goods[726] =new setGoods("0000a81814","145","60","42","nail","normal");
goods[727] =new setGoods("0000a81815","150","60","42","nail","normal");
goods[728] =new setGoods("0000a81816","90","30","50","nail","normal");
goods[729] =new setGoods("0000a81817","95","30","50","nail","normal");
goods[730] =new setGoods("0000a81818","100","30","50","nail","normal");
goods[731] =new setGoods("0000a81819","105","30","50","nail","normal");
goods[732] =new setGoods("0000a81820","110","30","50","nail","normal");
goods[733] =new setGoods("0000a81821","115","30","50","nail","normal");
goods[734] =new setGoods("0000a81822","120","30","50","nail","normal");
goods[735] =new setGoods("0000a81823","125","30","50","nail","normal");
goods[736] =new setGoods("0000a81824","130","30","50","nail","normal");
goods[737] =new setGoods("0000a81825","135","30","50","nail","normal");
goods[738] =new setGoods("0000a81826","140","30","50","nail","normal");
goods[739] =new setGoods("0000a81827","145","30","50","nail","normal");
goods[740] =new setGoods("0000a81828","150","30","50","nail","normal");
goods[741] =new setGoods("0000a81829","90","35","50","nail","normal");
goods[742] =new setGoods("0000a81830","95","35","50","nail","normal");
goods[743] =new setGoods("0000a81831","100","35","50","nail","normal");
goods[744] =new setGoods("0000a81832","105","35","50","nail","normal");
goods[745] =new setGoods("0000a81833","110","35","50","nail","normal");
goods[746] =new setGoods("0000a81834","115","35","50","nail","normal");
goods[747] =new setGoods("0000a81835","120","35","50","nail","normal");
goods[748] =new setGoods("0000a81836","125","35","50","nail","normal");
goods[749] =new setGoods("0000a81837","130","35","50","nail","normal");
goods[750] =new setGoods("0000a81838","135","35","50","nail","normal");
goods[751] =new setGoods("0000a81839","140","35","50","nail","normal");
goods[752] =new setGoods("0000a81840","145","35","50","nail","normal");
goods[753] =new setGoods("0000a81841","150","35","50","nail","normal");
goods[754] =new setGoods("0000a81842","90","40","50","nail","normal");
goods[755] =new setGoods("0000a81843","95","40","50","nail","normal");
goods[756] =new setGoods("0000a81844","100","40","50","nail","normal");
goods[757] =new setGoods("0000a81845","105","40","50","nail","normal");
goods[758] =new setGoods("0000a81846","110","40","50","nail","normal");
goods[759] =new setGoods("0000a81847","115","40","50","nail","normal");
goods[760] =new setGoods("0000a81848","120","40","50","nail","normal");
goods[761] =new setGoods("0000a81849","125","40","50","nail","normal");
goods[762] =new setGoods("0000a81850","130","40","50","nail","normal");
goods[763] =new setGoods("0000a81851","135","40","50","nail","normal");
goods[764] =new setGoods("0000a81852","140","40","50","nail","normal");
goods[765] =new setGoods("0000a81853","145","40","50","nail","normal");
goods[766] =new setGoods("0000a81854","150","40","50","nail","normal");
goods[767] =new setGoods("0000a81855","90","45","50","nail","normal");
goods[768] =new setGoods("0000a81856","95","45","50","nail","normal");
goods[769] =new setGoods("0000a81857","100","45","50","nail","normal");
goods[770] =new setGoods("0000a81858","105","45","50","nail","normal");
goods[771] =new setGoods("0000a81859","110","45","50","nail","normal");
goods[772] =new setGoods("0000a81860","115","45","50","nail","normal");
goods[773] =new setGoods("0000a81861","120","45","50","nail","normal");
goods[774] =new setGoods("0000a81862","125","45","50","nail","normal");
goods[775] =new setGoods("0000a81863","130","45","50","nail","normal");
goods[776] =new setGoods("0000a81864","135","45","50","nail","normal");
goods[777] =new setGoods("0000a81865","140","45","50","nail","normal");
goods[778] =new setGoods("0000a81866","145","45","50","nail","normal");
goods[779] =new setGoods("0000a81867","150","45","50","nail","normal");
goods[780] =new setGoods("0000a81868","90","50","50","nail","normal");
goods[781] =new setGoods("0000a81869","95","50","50","nail","normal");
goods[782] =new setGoods("0000a81870","100","50","50","nail","normal");
goods[783] =new setGoods("0000a81871","105","50","50","nail","normal");
goods[784] =new setGoods("0000a81872","110","50","50","nail","normal");
goods[785] =new setGoods("0000a81873","115","50","50","nail","normal");
goods[786] =new setGoods("0000a81874","120","50","50","nail","normal");
goods[787] =new setGoods("0000a81875","125","50","50","nail","normal");
goods[788] =new setGoods("0000a81876","130","50","50","nail","normal");
goods[789] =new setGoods("0000a81877","135","50","50","nail","normal");
goods[790] =new setGoods("0000a81878","140","50","50","nail","normal");
goods[791] =new setGoods("0000a81879","145","50","50","nail","normal");
goods[792] =new setGoods("0000a81880","150","50","50","nail","normal");
goods[793] =new setGoods("0000a81881","90","55","50","nail","normal");
goods[794] =new setGoods("0000a81882","95","55","50","nail","normal");
goods[795] =new setGoods("0000a81883","100","55","50","nail","normal");
goods[796] =new setGoods("0000a81884","105","55","50","nail","normal");
goods[797] =new setGoods("0000a81885","110","55","50","nail","normal");
goods[798] =new setGoods("0000a81886","115","55","50","nail","normal");
goods[799] =new setGoods("0000a81887","120","55","50","nail","normal");
goods[800] =new setGoods("0000a81888","125","55","50","nail","normal");
goods[801] =new setGoods("0000a81889","130","55","50","nail","normal");
goods[802] =new setGoods("0000a81890","135","55","50","nail","normal");
goods[803] =new setGoods("0000a81891","140","55","50","nail","normal");
goods[804] =new setGoods("0000a81892","145","55","50","nail","normal");
goods[805] =new setGoods("0000a81893","150","55","50","nail","normal");
goods[806] =new setGoods("0000a81894","90","60","50","nail","normal");
goods[807] =new setGoods("0000a81895","95","60","50","nail","normal");
goods[808] =new setGoods("0000a81896","100","60","50","nail","normal");
goods[809] =new setGoods("0000a81897","105","60","50","nail","normal");
goods[810] =new setGoods("0000a81898","110","60","50","nail","normal");
goods[811] =new setGoods("0000a81899","115","60","50","nail","normal");
goods[812] =new setGoods("0000a81900","120","60","50","nail","normal");
goods[813] =new setGoods("0000a81901","125","60","50","nail","normal");
goods[814] =new setGoods("0000a81902","130","60","50","nail","normal");
goods[815] =new setGoods("0000a81903","135","60","50","nail","normal");
goods[816] =new setGoods("0000a81904","140","60","50","nail","normal");
goods[817] =new setGoods("0000a81905","145","60","50","nail","normal");
goods[818] =new setGoods("0000a81906","150","60","50","nail","normal");
goods[819] =new setGoods("0000a81907","90","30","30","black","normal");
goods[820] =new setGoods("0000a81908","95","30","30","black","normal");
goods[821] =new setGoods("0000a81909","100","30","30","black","normal");
goods[822] =new setGoods("0000a81910","105","30","30","black","normal");
goods[823] =new setGoods("0000a81911","110","30","30","black","normal");
goods[824] =new setGoods("0000a81912","115","30","30","black","normal");
goods[825] =new setGoods("0000a81913","120","30","30","black","normal");
goods[826] =new setGoods("0000a81914","125","30","30","black","normal");
goods[827] =new setGoods("0000a81915","130","30","30","black","normal");
goods[828] =new setGoods("0000a81916","135","30","30","black","normal");
goods[829] =new setGoods("0000a81917","140","30","30","black","normal");
goods[830] =new setGoods("0000a81918","145","30","30","black","normal");
goods[831] =new setGoods("0000a81919","150","30","30","black","normal");
goods[832] =new setGoods("0000a81920","90","35","30","black","normal");
goods[833] =new setGoods("0000a81921","95","35","30","black","normal");
goods[834] =new setGoods("0000a81922","100","35","30","black","normal");
goods[835] =new setGoods("0000a81923","105","35","30","black","normal");
goods[836] =new setGoods("0000a81924","110","35","30","black","normal");
goods[837] =new setGoods("0000a81925","115","35","30","black","normal");
goods[838] =new setGoods("0000a81926","120","35","30","black","normal");
goods[839] =new setGoods("0000a81927","125","35","30","black","normal");
goods[840] =new setGoods("0000a81928","130","35","30","black","normal");
goods[841] =new setGoods("0000a81929","135","35","30","black","normal");
goods[842] =new setGoods("0000a81930","140","35","30","black","normal");
goods[843] =new setGoods("0000a81931","145","35","30","black","normal");
goods[844] =new setGoods("0000a81932","150","35","30","black","normal");
goods[845] =new setGoods("0000a81933","90","40","30","black","normal");
goods[846] =new setGoods("0000a81934","95","40","30","black","normal");
goods[847] =new setGoods("0000a81935","100","40","30","black","normal");
goods[848] =new setGoods("0000a81936","105","40","30","black","normal");
goods[849] =new setGoods("0000a81937","110","40","30","black","normal");
goods[850] =new setGoods("0000a81938","115","40","30","black","normal");
goods[851] =new setGoods("0000a81939","120","40","30","black","normal");
goods[852] =new setGoods("0000a81940","125","40","30","black","normal");
goods[853] =new setGoods("0000a81941","130","40","30","black","normal");
goods[854] =new setGoods("0000a81942","135","40","30","black","normal");
goods[855] =new setGoods("0000a81943","140","40","30","black","normal");
goods[856] =new setGoods("0000a81944","145","40","30","black","normal");
goods[857] =new setGoods("0000a81945","150","40","30","black","normal");
goods[858] =new setGoods("0000a81946","90","45","30","black","normal");
goods[859] =new setGoods("0000a81947","95","45","30","black","normal");
goods[860] =new setGoods("0000a81948","100","45","30","black","normal");
goods[861] =new setGoods("0000a81949","105","45","30","black","normal");
goods[862] =new setGoods("0000a81950","110","45","30","black","normal");
goods[863] =new setGoods("0000a81951","115","45","30","black","normal");
goods[864] =new setGoods("0000a81952","120","45","30","black","normal");
goods[865] =new setGoods("0000a81953","125","45","30","black","normal");
goods[866] =new setGoods("0000a81954","130","45","30","black","normal");
goods[867] =new setGoods("0000a81955","135","45","30","black","normal");
goods[868] =new setGoods("0000a81956","140","45","30","black","normal");
goods[869] =new setGoods("0000a81957","145","45","30","black","normal");
goods[870] =new setGoods("0000a81958","150","45","30","black","normal");
goods[871] =new setGoods("0000a81959","90","50","30","black","normal");
goods[872] =new setGoods("0000a81960","95","50","30","black","normal");
goods[873] =new setGoods("0000a81961","100","50","30","black","normal");
goods[874] =new setGoods("0000a81962","105","50","30","black","normal");
goods[875] =new setGoods("0000a81963","110","50","30","black","normal");
goods[876] =new setGoods("0000a81964","115","50","30","black","normal");
goods[877] =new setGoods("0000a81965","120","50","30","black","normal");
goods[878] =new setGoods("0000a81966","125","50","30","black","normal");
goods[879] =new setGoods("0000a81967","130","50","30","black","normal");
goods[880] =new setGoods("0000a81968","135","50","30","black","normal");
goods[881] =new setGoods("0000a81969","140","50","30","black","normal");
goods[882] =new setGoods("0000a81970","145","50","30","black","normal");
goods[883] =new setGoods("0000a81971","150","50","30","black","normal");
goods[884] =new setGoods("0000a81972","90","55","30","black","normal");
goods[885] =new setGoods("0000a81973","95","55","30","black","normal");
goods[886] =new setGoods("0000a81974","100","55","30","black","normal");
goods[887] =new setGoods("0000a81975","105","55","30","black","normal");
goods[888] =new setGoods("0000a81976","110","55","30","black","normal");
goods[889] =new setGoods("0000a81977","115","55","30","black","normal");
goods[890] =new setGoods("0000a81978","120","55","30","black","normal");
goods[891] =new setGoods("0000a81979","125","55","30","black","normal");
goods[892] =new setGoods("0000a81980","130","55","30","black","normal");
goods[893] =new setGoods("0000a81981","135","55","30","black","normal");
goods[894] =new setGoods("0000a81982","140","55","30","black","normal");
goods[895] =new setGoods("0000a81983","145","55","30","black","normal");
goods[896] =new setGoods("0000a81984","150","55","30","black","normal");
goods[897] =new setGoods("0000a81985","90","60","30","black","normal");
goods[898] =new setGoods("0000a81986","95","60","30","black","normal");
goods[899] =new setGoods("0000a81987","100","60","30","black","normal");
goods[900] =new setGoods("0000a81988","105","60","30","black","normal");
goods[901] =new setGoods("0000a81989","110","60","30","black","normal");
goods[902] =new setGoods("0000a81990","115","60","30","black","normal");
goods[903] =new setGoods("0000a81991","120","60","30","black","normal");
goods[904] =new setGoods("0000a81992","125","60","30","black","normal");
goods[905] =new setGoods("0000a81993","130","60","30","black","normal");
goods[906] =new setGoods("0000a81994","135","60","30","black","normal");
goods[907] =new setGoods("0000a81995","140","60","30","black","normal");
goods[908] =new setGoods("0000a81996","145","60","30","black","normal");
goods[909] =new setGoods("0000a81997","150","60","30","black","normal");
goods[910] =new setGoods("0000a81998","90","30","42","black","normal");
goods[911] =new setGoods("0000a81999","95","30","42","black","normal");
goods[912] =new setGoods("0000a82000","100","30","42","black","normal");
goods[913] =new setGoods("0000a82001","105","30","42","black","normal");
goods[914] =new setGoods("0000a82002","110","30","42","black","normal");
goods[915] =new setGoods("0000a82003","115","30","42","black","normal");
goods[916] =new setGoods("0000a82004","120","30","42","black","normal");
goods[917] =new setGoods("0000a82005","125","30","42","black","normal");
goods[918] =new setGoods("0000a82006","130","30","42","black","normal");
goods[919] =new setGoods("0000a82007","135","30","42","black","normal");
goods[920] =new setGoods("0000a82008","140","30","42","black","normal");
goods[921] =new setGoods("0000a82009","145","30","42","black","normal");
goods[922] =new setGoods("0000a82010","150","30","42","black","normal");
goods[923] =new setGoods("0000a82011","90","35","42","black","normal");
goods[924] =new setGoods("0000a82012","95","35","42","black","normal");
goods[925] =new setGoods("0000a82013","100","35","42","black","normal");
goods[926] =new setGoods("0000a82014","105","35","42","black","normal");
goods[927] =new setGoods("0000a82015","110","35","42","black","normal");
goods[928] =new setGoods("0000a82016","115","35","42","black","normal");
goods[929] =new setGoods("0000a82017","120","35","42","black","normal");
goods[930] =new setGoods("0000a82018","125","35","42","black","normal");
goods[931] =new setGoods("0000a82019","130","35","42","black","normal");
goods[932] =new setGoods("0000a82020","135","35","42","black","normal");
goods[933] =new setGoods("0000a82021","140","35","42","black","normal");
goods[934] =new setGoods("0000a82022","145","35","42","black","normal");
goods[935] =new setGoods("0000a82023","150","35","42","black","normal");
goods[936] =new setGoods("0000a82024","90","40","42","black","normal");
goods[937] =new setGoods("0000a82025","95","40","42","black","normal");

goods[938] =new setGoods("0000a82026","100","40","42","black","normal");
goods[939] =new setGoods("0000a82027","105","40","42","black","normal");
goods[940] =new setGoods("0000a82028","110","40","42","black","normal");
goods[941] =new setGoods("0000a82029","115","40","42","black","normal");
goods[942] =new setGoods("0000a82030","120","40","42","black","normal");
goods[943] =new setGoods("0000a82031","125","40","42","black","normal");
goods[944] =new setGoods("0000a82032","130","40","42","black","normal");
goods[945] =new setGoods("0000a82033","135","40","42","black","normal");
goods[946] =new setGoods("0000a82034","140","40","42","black","normal");
goods[947] =new setGoods("0000a82035","145","40","42","black","normal");
goods[948] =new setGoods("0000a82036","150","40","42","black","normal");
goods[949] =new setGoods("0000a82037","90","45","42","black","normal");
goods[950] =new setGoods("0000a82038","95","45","42","black","normal");
goods[951] =new setGoods("0000a82039","100","45","42","black","normal");
goods[952] =new setGoods("0000a82040","105","45","42","black","normal");
goods[953] =new setGoods("0000a82041","110","45","42","black","normal");
goods[954] =new setGoods("0000a82042","115","45","42","black","normal");
goods[955] =new setGoods("0000a82043","120","45","42","black","normal");
goods[956] =new setGoods("0000a82044","125","45","42","black","normal");
goods[957] =new setGoods("0000a82045","130","45","42","black","normal");
goods[958] =new setGoods("0000a82046","135","45","42","black","normal");
goods[959] =new setGoods("0000a82047","140","45","42","black","normal");
goods[960] =new setGoods("0000a82048","145","45","42","black","normal");
goods[961] =new setGoods("0000a82049","150","45","42","black","normal");
goods[962] =new setGoods("0000a82050","90","50","42","black","normal");
goods[963] =new setGoods("0000a82051","95","50","42","black","normal");
goods[964] =new setGoods("0000a82052","100","50","42","black","normal");
goods[965] =new setGoods("0000a82053","105","50","42","black","normal");
goods[966] =new setGoods("0000a82054","110","50","42","black","normal");
goods[967] =new setGoods("0000a82055","115","50","42","black","normal");
goods[968] =new setGoods("0000a82056","120","50","42","black","normal");
goods[969] =new setGoods("0000a82057","125","50","42","black","normal");
goods[970] =new setGoods("0000a82058","130","50","42","black","normal");
goods[971] =new setGoods("0000a82059","135","50","42","black","normal");
goods[972] =new setGoods("0000a82060","140","50","42","black","normal");
goods[973] =new setGoods("0000a82061","145","50","42","black","normal");
goods[974] =new setGoods("0000a82062","150","50","42","black","normal");
goods[975] =new setGoods("0000a82063","90","55","42","black","normal");
goods[976] =new setGoods("0000a82064","95","55","42","black","normal");
goods[977] =new setGoods("0000a82065","100","55","42","black","normal");
goods[978] =new setGoods("0000a82066","105","55","42","black","normal");
goods[979] =new setGoods("0000a50561","110","55","42","black","normal");
goods[980] =new setGoods("0000a82067","115","55","42","black","normal");
goods[981] =new setGoods("0000a82068","120","55","42","black","normal");
goods[982] =new setGoods("0000a82069","125","55","42","black","normal");
goods[983] =new setGoods("0000a82070","130","55","42","black","normal");
goods[984] =new setGoods("0000a82071","135","55","42","black","normal");
goods[985] =new setGoods("0000a82072","140","55","42","black","normal");
goods[986] =new setGoods("0000a82073","145","55","42","black","normal");
goods[987] =new setGoods("0000a82074","150","55","42","black","normal");
goods[988] =new setGoods("0000a82075","90","60","42","black","normal");
goods[989] =new setGoods("0000a82076","95","60","42","black","normal");
goods[990] =new setGoods("0000a82077","100","60","42","black","normal");
goods[991] =new setGoods("0000a82078","105","60","42","black","normal");
goods[992] =new setGoods("0000a82079","110","60","42","black","normal");
goods[993] =new setGoods("0000a82080","115","60","42","black","normal");
goods[994] =new setGoods("0000a82081","120","60","42","black","normal");
goods[995] =new setGoods("0000a82082","125","60","42","black","normal");
goods[996] =new setGoods("0000a82083","130","60","42","black","normal");
goods[997] =new setGoods("0000a82084","135","60","42","black","normal");
goods[998] =new setGoods("0000a82085","140","60","42","black","normal");
goods[999] =new setGoods("0000a82086","145","60","42","black","normal");
goods[1000] =new setGoods("0000a82087","150","60","42","black","normal");
goods[1001] =new setGoods("0000a82088","90","30","50","black","normal");
goods[1002] =new setGoods("0000a82089","95","30","50","black","normal");
goods[1003] =new setGoods("0000a82090","100","30","50","black","normal");
goods[1004] =new setGoods("0000a82091","105","30","50","black","normal");
goods[1005] =new setGoods("0000a82092","110","30","50","black","normal");
goods[1006] =new setGoods("0000a82093","115","30","50","black","normal");
goods[1007] =new setGoods("0000a82094","120","30","50","black","normal");
goods[1008] =new setGoods("0000a82095","125","30","50","black","normal");
goods[1009] =new setGoods("0000a82096","130","30","50","black","normal");
goods[1010] =new setGoods("0000a82097","135","30","50","black","normal");
goods[1011] =new setGoods("0000a82098","140","30","50","black","normal");
goods[1012] =new setGoods("0000a82099","145","30","50","black","normal");
goods[1013] =new setGoods("0000a82100","150","30","50","black","normal");
goods[1014] =new setGoods("0000a82101","90","35","50","black","normal");
goods[1015] =new setGoods("0000a82102","95","35","50","black","normal");
goods[1016] =new setGoods("0000a82103","100","35","50","black","normal");
goods[1017] =new setGoods("0000a82104","105","35","50","black","normal");
goods[1018] =new setGoods("0000a82105","110","35","50","black","normal");
goods[1019] =new setGoods("0000a82106","115","35","50","black","normal");
goods[1020] =new setGoods("0000a82107","120","35","50","black","normal");
goods[1021] =new setGoods("0000a82108","125","35","50","black","normal");
goods[1022] =new setGoods("0000a82109","130","35","50","black","normal");
goods[1023] =new setGoods("0000a82110","135","35","50","black","normal");
goods[1024] =new setGoods("0000a82111","140","35","50","black","normal");
goods[1025] =new setGoods("0000a82112","145","35","50","black","normal");
goods[1026] =new setGoods("0000a82113","150","35","50","black","normal");
goods[1027] =new setGoods("0000a82114","90","40","50","black","normal");
goods[1028] =new setGoods("0000a82115","95","40","50","black","normal");
goods[1029] =new setGoods("0000a82116","100","40","50","black","normal");
goods[1030] =new setGoods("0000a82117","105","40","50","black","normal");
goods[1031] =new setGoods("0000a82118","110","40","50","black","normal");
goods[1032] =new setGoods("0000a82119","115","40","50","black","normal");
goods[1033] =new setGoods("0000a82120","120","40","50","black","normal");
goods[1034] =new setGoods("0000a82121","125","40","50","black","normal");
goods[1035] =new setGoods("0000a82122","130","40","50","black","normal");
goods[1036] =new setGoods("0000a82123","135","40","50","black","normal");
goods[1037] =new setGoods("0000a82124","140","40","50","black","normal");
goods[1038] =new setGoods("0000a82125","145","40","50","black","normal");
goods[1039] =new setGoods("0000a82126","150","40","50","black","normal");
goods[1040] =new setGoods("0000a82127","90","45","50","black","normal");
goods[1041] =new setGoods("0000a82128","95","45","50","black","normal");
goods[1042] =new setGoods("0000a82129","100","45","50","black","normal");
goods[1043] =new setGoods("0000a82130","105","45","50","black","normal");
goods[1044] =new setGoods("0000a82131","110","45","50","black","normal");
goods[1045] =new setGoods("0000a82132","115","45","50","black","normal");
goods[1046] =new setGoods("0000a82133","120","45","50","black","normal");
goods[1047] =new setGoods("0000a82134","125","45","50","black","normal");
goods[1048] =new setGoods("0000a82135","130","45","50","black","normal");
goods[1049] =new setGoods("0000a82136","135","45","50","black","normal");
goods[1050] =new setGoods("0000a82137","140","45","50","black","normal");
goods[1051] =new setGoods("0000a82138","145","45","50","black","normal");
goods[1052] =new setGoods("0000a82139","150","45","50","black","normal");
goods[1053] =new setGoods("0000a82140","90","50","50","black","normal");
goods[1054] =new setGoods("0000a82141","95","50","50","black","normal");
goods[1055] =new setGoods("0000a82142","100","50","50","black","normal");
goods[1056] =new setGoods("0000a82143","105","50","50","black","normal");
goods[1057] =new setGoods("0000a82144","110","50","50","black","normal");
goods[1058] =new setGoods("0000a82145","115","50","50","black","normal");
goods[1059] =new setGoods("0000a82146","120","50","50","black","normal");
goods[1060] =new setGoods("0000a82147","125","50","50","black","normal");
goods[1061] =new setGoods("0000a82148","130","50","50","black","normal");
goods[1062] =new setGoods("0000a82149","135","50","50","black","normal");
goods[1063] =new setGoods("0000a82150","140","50","50","black","normal");
goods[1064] =new setGoods("0000a82151","145","50","50","black","normal");
goods[1065] =new setGoods("0000a82152","150","50","50","black","normal");
goods[1066] =new setGoods("0000a82153","90","55","50","black","normal");
goods[1067] =new setGoods("0000a82154","95","55","50","black","normal");
goods[1068] =new setGoods("0000a82155","100","55","50","black","normal");
goods[1069] =new setGoods("0000a82156","105","55","50","black","normal");
goods[1070] =new setGoods("0000a82157","110","55","50","black","normal");
goods[1071] =new setGoods("0000a82158","115","55","50","black","normal");
goods[1072] =new setGoods("0000a82159","120","55","50","black","normal");
goods[1073] =new setGoods("0000a82160","125","55","50","black","normal");
goods[1074] =new setGoods("0000a82161","130","55","50","black","normal");
goods[1075] =new setGoods("0000a82162","135","55","50","black","normal");
goods[1076] =new setGoods("0000a82163","140","55","50","black","normal");
goods[1077] =new setGoods("0000a82164","145","55","50","black","normal");
goods[1078] =new setGoods("0000a82165","150","55","50","black","normal");
goods[1079] =new setGoods("0000a82166","90","60","50","black","normal");
goods[1080] =new setGoods("0000a82167","95","60","50","black","normal");
goods[1081] =new setGoods("0000a82168","100","60","50","black","normal");
goods[1082] =new setGoods("0000a82169","105","60","50","black","normal");
goods[1083] =new setGoods("0000a82170","110","60","50","black","normal");
goods[1084] =new setGoods("0000a82171","115","60","50","black","normal");
goods[1085] =new setGoods("0000a82172","120","60","50","black","normal");
goods[1086] =new setGoods("0000a82173","125","60","50","black","normal");
goods[1087] =new setGoods("0000a82174","130","60","50","black","normal");
goods[1088] =new setGoods("0000a82175","135","60","50","black","normal");
goods[1089] =new setGoods("0000a82176","140","60","50","black","normal");
goods[1090] =new setGoods("0000a82177","145","60","50","black","normal");
goods[1091] =new setGoods("0000a82178","150","60","50","black","normal");
goods[1092] =new setGoods("0000a82179","90","30","30","bp","normal");
goods[1093] =new setGoods("0000a82180","95","30","30","bp","normal");
goods[1094] =new setGoods("0000a82181","100","30","30","bp","normal");
goods[1095] =new setGoods("0000a82182","105","30","30","bp","normal");
goods[1096] =new setGoods("0000a82183","110","30","30","bp","normal");
goods[1097] =new setGoods("0000a82184","115","30","30","bp","normal");
goods[1098] =new setGoods("0000a82185","120","30","30","bp","normal");
goods[1099] =new setGoods("0000a82186","125","30","30","bp","normal");
goods[1100] =new setGoods("0000a82187","130","30","30","bp","normal");
goods[1101] =new setGoods("0000a82188","135","30","30","bp","normal");
goods[1102] =new setGoods("0000a82189","140","30","30","bp","normal");
goods[1103] =new setGoods("0000a82190","145","30","30","bp","normal");
goods[1104] =new setGoods("0000a82191","150","30","30","bp","normal");
goods[1105] =new setGoods("0000a82192","90","35","30","bp","normal");
goods[1106] =new setGoods("0000a82193","95","35","30","bp","normal");
goods[1107] =new setGoods("0000a82194","100","35","30","bp","normal");
goods[1108] =new setGoods("0000a82195","105","35","30","bp","normal");
goods[1109] =new setGoods("0000a82196","110","35","30","bp","normal");
goods[1110] =new setGoods("0000a82197","115","35","30","bp","normal");
goods[1111] =new setGoods("0000a82198","120","35","30","bp","normal");
goods[1112] =new setGoods("0000a82199","125","35","30","bp","normal");
goods[1113] =new setGoods("0000a82200","130","35","30","bp","normal");
goods[1114] =new setGoods("0000a82201","135","35","30","bp","normal");
goods[1115] =new setGoods("0000a82202","140","35","30","bp","normal");
goods[1116] =new setGoods("0000a82203","145","35","30","bp","normal");
goods[1117] =new setGoods("0000a82204","150","35","30","bp","normal");
goods[1118] =new setGoods("0000a82205","90","40","30","bp","normal");
goods[1119] =new setGoods("0000a82206","95","40","30","bp","normal");
goods[1120] =new setGoods("0000a82207","100","40","30","bp","normal");
goods[1121] =new setGoods("0000a82208","105","40","30","bp","normal");
goods[1122] =new setGoods("0000a82209","110","40","30","bp","normal");
goods[1123] =new setGoods("0000a82210","115","40","30","bp","normal");
goods[1124] =new setGoods("0000a82211","120","40","30","bp","normal");
goods[1125] =new setGoods("0000a82212","125","40","30","bp","normal");
goods[1126] =new setGoods("0000a82213","130","40","30","bp","normal");
goods[1127] =new setGoods("0000a82214","135","40","30","bp","normal");
goods[1128] =new setGoods("0000a82215","140","40","30","bp","normal");
goods[1129] =new setGoods("0000a82216","145","40","30","bp","normal");
goods[1130] =new setGoods("0000a82217","150","40","30","bp","normal");
goods[1131] =new setGoods("0000a82218","90","45","30","bp","normal");
goods[1132] =new setGoods("0000a82219","95","45","30","bp","normal");
goods[1133] =new setGoods("0000a82220","100","45","30","bp","normal");
goods[1134] =new setGoods("0000a82221","105","45","30","bp","normal");
goods[1135] =new setGoods("0000a82222","110","45","30","bp","normal");
goods[1136] =new setGoods("0000a82223","115","45","30","bp","normal");
goods[1137] =new setGoods("0000a82224","120","45","30","bp","normal");
goods[1138] =new setGoods("0000a82225","125","45","30","bp","normal");
goods[1139] =new setGoods("0000a82226","130","45","30","bp","normal");
goods[1140] =new setGoods("0000a82227","135","45","30","bp","normal");
goods[1141] =new setGoods("0000a82228","140","45","30","bp","normal");
goods[1142] =new setGoods("0000a82229","145","45","30","bp","normal");
goods[1143] =new setGoods("0000a82230","150","45","30","bp","normal");
goods[1144] =new setGoods("0000a82231","90","50","30","bp","normal");
goods[1145] =new setGoods("0000a82232","95","50","30","bp","normal");
goods[1146] =new setGoods("0000a82233","100","50","30","bp","normal");
goods[1147] =new setGoods("0000a82234","105","50","30","bp","normal");
goods[1148] =new setGoods("0000a82235","110","50","30","bp","normal");
goods[1149] =new setGoods("0000a82236","115","50","30","bp","normal");
goods[1150] =new setGoods("0000a82237","120","50","30","bp","normal");
goods[1151] =new setGoods("0000a82238","125","50","30","bp","normal");
goods[1152] =new setGoods("0000a82239","130","50","30","bp","normal");
goods[1153] =new setGoods("0000a82240","135","50","30","bp","normal");
goods[1154] =new setGoods("0000a82241","140","50","30","bp","normal");
goods[1155] =new setGoods("0000a82242","145","50","30","bp","normal");
goods[1156] =new setGoods("0000a82243","150","50","30","bp","normal");
goods[1157] =new setGoods("0000a82244","90","55","30","bp","normal");
goods[1158] =new setGoods("0000a82245","95","55","30","bp","normal");
goods[1159] =new setGoods("0000a82246","100","55","30","bp","normal");
goods[1160] =new setGoods("0000a82247","105","55","30","bp","normal");
goods[1161] =new setGoods("0000a82248","110","55","30","bp","normal");
goods[1162] =new setGoods("0000a82249","115","55","30","bp","normal");
goods[1163] =new setGoods("0000a82250","120","55","30","bp","normal");
goods[1164] =new setGoods("0000a82251","125","55","30","bp","normal");
goods[1165] =new setGoods("0000a82252","130","55","30","bp","normal");
goods[1166] =new setGoods("0000a82253","135","55","30","bp","normal");
goods[1167] =new setGoods("0000a82254","140","55","30","bp","normal");
goods[1168] =new setGoods("0000a82255","145","55","30","bp","normal");
goods[1169] =new setGoods("0000a82256","150","55","30","bp","normal");
goods[1170] =new setGoods("0000a82257","90","60","30","bp","normal");
goods[1171] =new setGoods("0000a82258","95","60","30","bp","normal");
goods[1172] =new setGoods("0000a82259","100","60","30","bp","normal");
goods[1173] =new setGoods("0000a82260","105","60","30","bp","normal");
goods[1174] =new setGoods("0000a82261","110","60","30","bp","normal");
goods[1175] =new setGoods("0000a82262","115","60","30","bp","normal");
goods[1176] =new setGoods("0000a82263","120","60","30","bp","normal");
goods[1177] =new setGoods("0000a82264","125","60","30","bp","normal");
goods[1178] =new setGoods("0000a82265","130","60","30","bp","normal");
goods[1179] =new setGoods("0000a82266","135","60","30","bp","normal");
goods[1180] =new setGoods("0000a82267","140","60","30","bp","normal");
goods[1181] =new setGoods("0000a82268","145","60","30","bp","normal");
goods[1182] =new setGoods("0000a82269","150","60","30","bp","normal");
goods[1183] =new setGoods("0000a82270","90","30","42","bp","normal");
goods[1184] =new setGoods("0000a82271","95","30","42","bp","normal");
goods[1185] =new setGoods("0000a82272","100","30","42","bp","normal");
goods[1186] =new setGoods("0000a82273","105","30","42","bp","normal");
goods[1187] =new setGoods("0000a82274","110","30","42","bp","normal");
goods[1188] =new setGoods("0000a82275","115","30","42","bp","normal");
goods[1189] =new setGoods("0000a82276","120","30","42","bp","normal");
goods[1190] =new setGoods("0000a82277","125","30","42","bp","normal");
goods[1191] =new setGoods("0000a82278","130","30","42","bp","normal");
goods[1192] =new setGoods("0000a82279","135","30","42","bp","normal");
goods[1193] =new setGoods("0000a82280","140","30","42","bp","normal");
goods[1194] =new setGoods("0000a82281","145","30","42","bp","normal");
goods[1195] =new setGoods("0000a82282","150","30","42","bp","normal");
goods[1196] =new setGoods("0000a82283","90","35","42","bp","normal");
goods[1197] =new setGoods("0000a82284","95","35","42","bp","normal");
goods[1198] =new setGoods("0000a82285","100","35","42","bp","normal");
goods[1199] =new setGoods("0000a82286","105","35","42","bp","normal");
goods[1200] =new setGoods("0000a82287","110","35","42","bp","normal");
goods[1201] =new setGoods("0000a82288","115","35","42","bp","normal");
goods[1202] =new setGoods("0000a82289","120","35","42","bp","normal");
goods[1203] =new setGoods("0000a82290","125","35","42","bp","normal");
goods[1204] =new setGoods("0000a82291","130","35","42","bp","normal");
goods[1205] =new setGoods("0000a82292","135","35","42","bp","normal");
goods[1206] =new setGoods("0000a82293","140","35","42","bp","normal");
goods[1207] =new setGoods("0000a82294","145","35","42","bp","normal");
goods[1208] =new setGoods("0000a82295","150","35","42","bp","normal");
goods[1209] =new setGoods("0000a82296","90","40","42","bp","normal");
goods[1210] =new setGoods("0000a82297","95","40","42","bp","normal");
goods[1211] =new setGoods("0000a82298","100","40","42","bp","normal");
goods[1212] =new setGoods("0000a82299","105","40","42","bp","normal");
goods[1213] =new setGoods("0000a82300","110","40","42","bp","normal");
goods[1214] =new setGoods("0000a82301","115","40","42","bp","normal");
goods[1215] =new setGoods("0000a82302","120","40","42","bp","normal");
goods[1216] =new setGoods("0000a82303","125","40","42","bp","normal");
goods[1217] =new setGoods("0000a82304","130","40","42","bp","normal");
goods[1218] =new setGoods("0000a82305","135","40","42","bp","normal");
goods[1219] =new setGoods("0000a82306","140","40","42","bp","normal");
goods[1220] =new setGoods("0000a82307","145","40","42","bp","normal");
goods[1221] =new setGoods("0000a82308","150","40","42","bp","normal");
goods[1222] =new setGoods("0000a82309","90","45","42","bp","normal");
goods[1223] =new setGoods("0000a82310","95","45","42","bp","normal");
goods[1224] =new setGoods("0000a82311","100","45","42","bp","normal");
goods[1225] =new setGoods("0000a82312","105","45","42","bp","normal");
goods[1226] =new setGoods("0000a82313","110","45","42","bp","normal");
goods[1227] =new setGoods("0000a82314","115","45","42","bp","normal");
goods[1228] =new setGoods("0000a82315","120","45","42","bp","normal");
goods[1229] =new setGoods("0000a82316","125","45","42","bp","normal");
goods[1230] =new setGoods("0000a82317","130","45","42","bp","normal");
goods[1231] =new setGoods("0000a82318","135","45","42","bp","normal");
goods[1232] =new setGoods("0000a82319","140","45","42","bp","normal");
goods[1233] =new setGoods("0000a82320","145","45","42","bp","normal");
goods[1234] =new setGoods("0000a82321","150","45","42","bp","normal");
goods[1235] =new setGoods("0000a82322","90","50","42","bp","normal");
goods[1236] =new setGoods("0000a82323","95","50","42","bp","normal");
goods[1237] =new setGoods("0000a82324","100","50","42","bp","normal");
goods[1238] =new setGoods("0000a82325","105","50","42","bp","normal");
goods[1239] =new setGoods("0000a82326","110","50","42","bp","normal");
goods[1240] =new setGoods("0000a82327","115","50","42","bp","normal");
goods[1241] =new setGoods("0000a82328","120","50","42","bp","normal");
goods[1242] =new setGoods("0000a82329","125","50","42","bp","normal");
goods[1243] =new setGoods("0000a82330","130","50","42","bp","normal");
goods[1244] =new setGoods("0000a82331","135","50","42","bp","normal");
goods[1245] =new setGoods("0000a82332","140","50","42","bp","normal");
goods[1246] =new setGoods("0000a82333","145","50","42","bp","normal");
goods[1247] =new setGoods("0000a82334","150","50","42","bp","normal");
goods[1248] =new setGoods("0000a82335","90","55","42","bp","normal");
goods[1249] =new setGoods("0000a82336","95","55","42","bp","normal");
goods[1250] =new setGoods("0000a82337","100","55","42","bp","normal");
goods[1251] =new setGoods("0000a82338","105","55","42","bp","normal");
goods[1252] =new setGoods("0000a39402","110","55","42","bp","normal");
goods[1253] =new setGoods("0000a82339","115","55","42","bp","normal");
goods[1254] =new setGoods("0000a82340","120","55","42","bp","normal");
goods[1255] =new setGoods("0000a82341","125","55","42","bp","normal");
goods[1256] =new setGoods("0000a82342","130","55","42","bp","normal");
goods[1257] =new setGoods("0000a82343","135","55","42","bp","normal");
goods[1258] =new setGoods("0000a82344","140","55","42","bp","normal");
goods[1259] =new setGoods("0000a82345","145","55","42","bp","normal");
goods[1260] =new setGoods("0000a82346","150","55","42","bp","normal");
goods[1261] =new setGoods("0000a82347","90","60","42","bp","normal");
goods[1262] =new setGoods("0000a82348","95","60","42","bp","normal");
goods[1263] =new setGoods("0000a82349","100","60","42","bp","normal");
goods[1264] =new setGoods("0000a82350","105","60","42","bp","normal");
goods[1265] =new setGoods("0000a82351","110","60","42","bp","normal");
goods[1266] =new setGoods("0000a82352","115","60","42","bp","normal");
goods[1267] =new setGoods("0000a82353","120","60","42","bp","normal");
goods[1268] =new setGoods("0000a82354","125","60","42","bp","normal");
goods[1269] =new setGoods("0000a82355","130","60","42","bp","normal");
goods[1270] =new setGoods("0000a82356","135","60","42","bp","normal");
goods[1271] =new setGoods("0000a82357","140","60","42","bp","normal");
goods[1272] =new setGoods("0000a82358","145","60","42","bp","normal");
goods[1273] =new setGoods("0000a82359","150","60","42","bp","normal");
goods[1274] =new setGoods("0000a82360","90","30","50","bp","normal");
goods[1275] =new setGoods("0000a82361","95","30","50","bp","normal");
goods[1276] =new setGoods("0000a82362","100","30","50","bp","normal");
goods[1277] =new setGoods("0000a82363","105","30","50","bp","normal");
goods[1278] =new setGoods("0000a82364","110","30","50","bp","normal");
goods[1279] =new setGoods("0000a82365","115","30","50","bp","normal");
goods[1280] =new setGoods("0000a82366","120","30","50","bp","normal");
goods[1281] =new setGoods("0000a82367","125","30","50","bp","normal");
goods[1282] =new setGoods("0000a82368","130","30","50","bp","normal");
goods[1283] =new setGoods("0000a82369","135","30","50","bp","normal");
goods[1284] =new setGoods("0000a82370","140","30","50","bp","normal");
goods[1285] =new setGoods("0000a82371","145","30","50","bp","normal");
goods[1286] =new setGoods("0000a82372","150","30","50","bp","normal");
goods[1287] =new setGoods("0000a82373","90","35","50","bp","normal");
goods[1288] =new setGoods("0000a82374","95","35","50","bp","normal");
goods[1289] =new setGoods("0000a82375","100","35","50","bp","normal");
goods[1290] =new setGoods("0000a82376","105","35","50","bp","normal");
goods[1291] =new setGoods("0000a82377","110","35","50","bp","normal");
goods[1292] =new setGoods("0000a82378","115","35","50","bp","normal");
goods[1293] =new setGoods("0000a82379","120","35","50","bp","normal");
goods[1294] =new setGoods("0000a82380","125","35","50","bp","normal");
goods[1295] =new setGoods("0000a82381","130","35","50","bp","normal");
goods[1296] =new setGoods("0000a82382","135","35","50","bp","normal");
goods[1297] =new setGoods("0000a82383","140","35","50","bp","normal");
goods[1298] =new setGoods("0000a82384","145","35","50","bp","normal");
goods[1299] =new setGoods("0000a82385","150","35","50","bp","normal");
goods[1300] =new setGoods("0000a82386","90","40","50","bp","normal");
goods[1301] =new setGoods("0000a82387","95","40","50","bp","normal");
goods[1302] =new setGoods("0000a82388","100","40","50","bp","normal");
goods[1303] =new setGoods("0000a82389","105","40","50","bp","normal");
goods[1304] =new setGoods("0000a82390","110","40","50","bp","normal");
goods[1305] =new setGoods("0000a82391","115","40","50","bp","normal");
goods[1306] =new setGoods("0000a82392","120","40","50","bp","normal");
goods[1307] =new setGoods("0000a82393","125","40","50","bp","normal");
goods[1308] =new setGoods("0000a82394","130","40","50","bp","normal");
goods[1309] =new setGoods("0000a82395","135","40","50","bp","normal");
goods[1310] =new setGoods("0000a82396","140","40","50","bp","normal");
goods[1311] =new setGoods("0000a82397","145","40","50","bp","normal");
goods[1312] =new setGoods("0000a82398","150","40","50","bp","normal");
goods[1313] =new setGoods("0000a82399","90","45","50","bp","normal");
goods[1314] =new setGoods("0000a82400","95","45","50","bp","normal");
goods[1315] =new setGoods("0000a82401","100","45","50","bp","normal");
goods[1316] =new setGoods("0000a82402","105","45","50","bp","normal");
goods[1317] =new setGoods("0000a82403","110","45","50","bp","normal");
goods[1318] =new setGoods("0000a82404","115","45","50","bp","normal");
goods[1319] =new setGoods("0000a82405","120","45","50","bp","normal");
goods[1320] =new setGoods("0000a82406","125","45","50","bp","normal");
goods[1321] =new setGoods("0000a82407","130","45","50","bp","normal");
goods[1322] =new setGoods("0000a82408","135","45","50","bp","normal");
goods[1323] =new setGoods("0000a82409","140","45","50","bp","normal");
goods[1324] =new setGoods("0000a82410","145","45","50","bp","normal");
goods[1325] =new setGoods("0000a82411","150","45","50","bp","normal");
goods[1326] =new setGoods("0000a82412","90","50","50","bp","normal");
goods[1327] =new setGoods("0000a82413","95","50","50","bp","normal");
goods[1328] =new setGoods("0000a82414","100","50","50","bp","normal");
goods[1329] =new setGoods("0000a82415","105","50","50","bp","normal");
goods[1330] =new setGoods("0000a82416","110","50","50","bp","normal");
goods[1331] =new setGoods("0000a82417","115","50","50","bp","normal");
goods[1332] =new setGoods("0000a82418","120","50","50","bp","normal");
goods[1333] =new setGoods("0000a82419","125","50","50","bp","normal");
goods[1334] =new setGoods("0000a82420","130","50","50","bp","normal");
goods[1335] =new setGoods("0000a82421","135","50","50","bp","normal");
goods[1336] =new setGoods("0000a82422","140","50","50","bp","normal");
goods[1337] =new setGoods("0000a82423","145","50","50","bp","normal");
goods[1338] =new setGoods("0000a82424","150","50","50","bp","normal");
goods[1339] =new setGoods("0000a82425","90","55","50","bp","normal");
goods[1340] =new setGoods("0000a82426","95","55","50","bp","normal");
goods[1341] =new setGoods("0000a82427","100","55","50","bp","normal");
goods[1342] =new setGoods("0000a82428","105","55","50","bp","normal");
goods[1343] =new setGoods("0000a82429","110","55","50","bp","normal");
goods[1344] =new setGoods("0000a82430","115","55","50","bp","normal");
goods[1345] =new setGoods("0000a82431","120","55","50","bp","normal");
goods[1346] =new setGoods("0000a82432","125","55","50","bp","normal");
goods[1347] =new setGoods("0000a82433","130","55","50","bp","normal");
goods[1348] =new setGoods("0000a82434","135","55","50","bp","normal");
goods[1349] =new setGoods("0000a82435","140","55","50","bp","normal");
goods[1350] =new setGoods("0000a82436","145","55","50","bp","normal");
goods[1351] =new setGoods("0000a82437","150","55","50","bp","normal");
goods[1352] =new setGoods("0000a82438","90","60","50","bp","normal");
goods[1353] =new setGoods("0000a82439","95","60","50","bp","normal");
goods[1354] =new setGoods("0000a82440","100","60","50","bp","normal");
goods[1355] =new setGoods("0000a82441","105","60","50","bp","normal");
goods[1356] =new setGoods("0000a82442","110","60","50","bp","normal");
goods[1357] =new setGoods("0000a82443","115","60","50","bp","normal");
goods[1358] =new setGoods("0000a82444","120","60","50","bp","normal");
goods[1359] =new setGoods("0000a82445","125","60","50","bp","normal");
goods[1360] =new setGoods("0000a82446","130","60","50","bp","normal");
goods[1361] =new setGoods("0000a82447","135","60","50","bp","normal");
goods[1362] =new setGoods("0000a82448","140","60","50","bp","normal");
goods[1363] =new setGoods("0000a82449","145","60","50","bp","normal");
goods[1364] =new setGoods("0000a82450","150","60","50","bp","normal");
goods[1365] =new setGoods("0000a82451","90","30","30","mb","normal");
goods[1366] =new setGoods("0000a82452","95","30","30","mb","normal");
goods[1367] =new setGoods("0000a82453","100","30","30","mb","normal");
goods[1368] =new setGoods("0000a82454","105","30","30","mb","normal");
goods[1369] =new setGoods("0000a82455","110","30","30","mb","normal");
goods[1370] =new setGoods("0000a82456","115","30","30","mb","normal");
goods[1371] =new setGoods("0000a82457","120","30","30","mb","normal");
goods[1372] =new setGoods("0000a82458","125","30","30","mb","normal");
goods[1373] =new setGoods("0000a82459","130","30","30","mb","normal");
goods[1374] =new setGoods("0000a82460","135","30","30","mb","normal");
goods[1375] =new setGoods("0000a82461","140","30","30","mb","normal");
goods[1376] =new setGoods("0000a82462","145","30","30","mb","normal");
goods[1377] =new setGoods("0000a82463","150","30","30","mb","normal");
goods[1378] =new setGoods("0000a82464","90","35","30","mb","normal");
goods[1379] =new setGoods("0000a82465","95","35","30","mb","normal");
goods[1380] =new setGoods("0000a82466","100","35","30","mb","normal");
goods[1381] =new setGoods("0000a82467","105","35","30","mb","normal");
goods[1382] =new setGoods("0000a82468","110","35","30","mb","normal");
goods[1383] =new setGoods("0000a82469","115","35","30","mb","normal");
goods[1384] =new setGoods("0000a82470","120","35","30","mb","normal");
goods[1385] =new setGoods("0000a82471","125","35","30","mb","normal");
goods[1386] =new setGoods("0000a82472","130","35","30","mb","normal");
goods[1387] =new setGoods("0000a82473","135","35","30","mb","normal");
goods[1388] =new setGoods("0000a82474","140","35","30","mb","normal");
goods[1389] =new setGoods("0000a82475","145","35","30","mb","normal");
goods[1390] =new setGoods("0000a82476","150","35","30","mb","normal");
goods[1391] =new setGoods("0000a82477","90","40","30","mb","normal");
goods[1392] =new setGoods("0000a82478","95","40","30","mb","normal");
goods[1393] =new setGoods("0000a82479","100","40","30","mb","normal");
goods[1394] =new setGoods("0000a82480","105","40","30","mb","normal");
goods[1395] =new setGoods("0000a82481","110","40","30","mb","normal");
goods[1396] =new setGoods("0000a82482","115","40","30","mb","normal");
goods[1397] =new setGoods("0000a82483","120","40","30","mb","normal");
goods[1398] =new setGoods("0000a82484","125","40","30","mb","normal");
goods[1399] =new setGoods("0000a82485","130","40","30","mb","normal");
goods[1400] =new setGoods("0000a82486","135","40","30","mb","normal");
goods[1401] =new setGoods("0000a82487","140","40","30","mb","normal");
goods[1402] =new setGoods("0000a82488","145","40","30","mb","normal");
goods[1403] =new setGoods("0000a82489","150","40","30","mb","normal");
goods[1404] =new setGoods("0000a82490","90","45","30","mb","normal");
goods[1405] =new setGoods("0000a82491","95","45","30","mb","normal");
goods[1406] =new setGoods("0000a82492","100","45","30","mb","normal");
goods[1407] =new setGoods("0000a82493","105","45","30","mb","normal");
goods[1408] =new setGoods("0000a82494","110","45","30","mb","normal");
goods[1409] =new setGoods("0000a82495","115","45","30","mb","normal");
goods[1410] =new setGoods("0000a82496","120","45","30","mb","normal");
goods[1411] =new setGoods("0000a82497","125","45","30","mb","normal");
goods[1412] =new setGoods("0000a82498","130","45","30","mb","normal");
goods[1413] =new setGoods("0000a82499","135","45","30","mb","normal");
goods[1414] =new setGoods("0000a82500","140","45","30","mb","normal");
goods[1415] =new setGoods("0000a82501","145","45","30","mb","normal");
goods[1416] =new setGoods("0000a82502","150","45","30","mb","normal");
goods[1417] =new setGoods("0000a82503","90","50","30","mb","normal");
goods[1418] =new setGoods("0000a82504","95","50","30","mb","normal");
goods[1419] =new setGoods("0000a82505","100","50","30","mb","normal");
goods[1420] =new setGoods("0000a82506","105","50","30","mb","normal");
goods[1421] =new setGoods("0000a82507","110","50","30","mb","normal");
goods[1422] =new setGoods("0000a82508","115","50","30","mb","normal");
goods[1423] =new setGoods("0000a82509","120","50","30","mb","normal");
goods[1424] =new setGoods("0000a82510","125","50","30","mb","normal");
goods[1425] =new setGoods("0000a82511","130","50","30","mb","normal");
goods[1426] =new setGoods("0000a82512","135","50","30","mb","normal");
goods[1427] =new setGoods("0000a82513","140","50","30","mb","normal");
goods[1428] =new setGoods("0000a82514","145","50","30","mb","normal");
goods[1429] =new setGoods("0000a82515","150","50","30","mb","normal");
goods[1430] =new setGoods("0000a82516","90","55","30","mb","normal");
goods[1431] =new setGoods("0000a82517","95","55","30","mb","normal");
goods[1432] =new setGoods("0000a82518","100","55","30","mb","normal");
goods[1433] =new setGoods("0000a82519","105","55","30","mb","normal");
goods[1434] =new setGoods("0000a82520","110","55","30","mb","normal");
goods[1435] =new setGoods("0000a82521","115","55","30","mb","normal");
goods[1436] =new setGoods("0000a82522","120","55","30","mb","normal");
goods[1437] =new setGoods("0000a82523","125","55","30","mb","normal");
goods[1438] =new setGoods("0000a82524","130","55","30","mb","normal");
goods[1439] =new setGoods("0000a82525","135","55","30","mb","normal");
goods[1440] =new setGoods("0000a82526","140","55","30","mb","normal");
goods[1441] =new setGoods("0000a82527","145","55","30","mb","normal");
goods[1442] =new setGoods("0000a82528","150","55","30","mb","normal");
goods[1443] =new setGoods("0000a82529","90","60","30","mb","normal");
goods[1444] =new setGoods("0000a82530","95","60","30","mb","normal");
goods[1445] =new setGoods("0000a82531","100","60","30","mb","normal");
goods[1446] =new setGoods("0000a82532","105","60","30","mb","normal");
goods[1447] =new setGoods("0000a82533","110","60","30","mb","normal");
goods[1448] =new setGoods("0000a82534","115","60","30","mb","normal");
goods[1449] =new setGoods("0000a82535","120","60","30","mb","normal");
goods[1450] =new setGoods("0000a82536","125","60","30","mb","normal");
goods[1451] =new setGoods("0000a82537","130","60","30","mb","normal");
goods[1452] =new setGoods("0000a82538","135","60","30","mb","normal");
goods[1453] =new setGoods("0000a82539","140","60","30","mb","normal");
goods[1454] =new setGoods("0000a82540","145","60","30","mb","normal");
goods[1455] =new setGoods("0000a82541","150","60","30","mb","normal");
goods[1456] =new setGoods("0000a82542","90","30","42","mb","normal");
goods[1457] =new setGoods("0000a82543","95","30","42","mb","normal");
goods[1458] =new setGoods("0000a82544","100","30","42","mb","normal");
goods[1459] =new setGoods("0000a82545","105","30","42","mb","normal");
goods[1460] =new setGoods("0000a82546","110","30","42","mb","normal");
goods[1461] =new setGoods("0000a82547","115","30","42","mb","normal");
goods[1462] =new setGoods("0000a82548","120","30","42","mb","normal");
goods[1463] =new setGoods("0000a82549","125","30","42","mb","normal");
goods[1464] =new setGoods("0000a82550","130","30","42","mb","normal");
goods[1465] =new setGoods("0000a82551","135","30","42","mb","normal");
goods[1466] =new setGoods("0000a82552","140","30","42","mb","normal");
goods[1467] =new setGoods("0000a82553","145","30","42","mb","normal");
goods[1468] =new setGoods("0000a82554","150","30","42","mb","normal");
goods[1469] =new setGoods("0000a82555","90","35","42","mb","normal");
goods[1470] =new setGoods("0000a82556","95","35","42","mb","normal");
goods[1471] =new setGoods("0000a82557","100","35","42","mb","normal");
goods[1472] =new setGoods("0000a82558","105","35","42","mb","normal");
goods[1473] =new setGoods("0000a82559","110","35","42","mb","normal");
goods[1474] =new setGoods("0000a82560","115","35","42","mb","normal");
goods[1475] =new setGoods("0000a82561","120","35","42","mb","normal");
goods[1476] =new setGoods("0000a82562","125","35","42","mb","normal");
goods[1477] =new setGoods("0000a82563","130","35","42","mb","normal");
goods[1478] =new setGoods("0000a82564","135","35","42","mb","normal");
goods[1479] =new setGoods("0000a82565","140","35","42","mb","normal");
goods[1480] =new setGoods("0000a82566","145","35","42","mb","normal");
goods[1481] =new setGoods("0000a82567","150","35","42","mb","normal");
goods[1482] =new setGoods("0000a82568","90","40","42","mb","normal");
goods[1483] =new setGoods("0000a82569","95","40","42","mb","normal");
goods[1484] =new setGoods("0000a82570","100","40","42","mb","normal");
goods[1485] =new setGoods("0000a82571","105","40","42","mb","normal");
goods[1486] =new setGoods("0000a82572","110","40","42","mb","normal");
goods[1487] =new setGoods("0000a82573","115","40","42","mb","normal");
goods[1488] =new setGoods("0000a82574","120","40","42","mb","normal");
goods[1489] =new setGoods("0000a82575","125","40","42","mb","normal");
goods[1490] =new setGoods("0000a82576","130","40","42","mb","normal");
goods[1491] =new setGoods("0000a82577","135","40","42","mb","normal");
goods[1492] =new setGoods("0000a82578","140","40","42","mb","normal");
goods[1493] =new setGoods("0000a82579","145","40","42","mb","normal");
goods[1494] =new setGoods("0000a82580","150","40","42","mb","normal");
goods[1495] =new setGoods("0000a82581","90","45","42","mb","normal");
goods[1496] =new setGoods("0000a82582","95","45","42","mb","normal");
goods[1497] =new setGoods("0000a82583","100","45","42","mb","normal");
goods[1498] =new setGoods("0000a82584","105","45","42","mb","normal");
goods[1499] =new setGoods("0000a82585","110","45","42","mb","normal");
goods[1500] =new setGoods("0000a82586","115","45","42","mb","normal");
goods[1501] =new setGoods("0000a82587","120","45","42","mb","normal");
goods[1502] =new setGoods("0000a82588","125","45","42","mb","normal");
goods[1503] =new setGoods("0000a82589","130","45","42","mb","normal");
goods[1504] =new setGoods("0000a82590","135","45","42","mb","normal");
goods[1505] =new setGoods("0000a82591","140","45","42","mb","normal");
goods[1506] =new setGoods("0000a82592","145","45","42","mb","normal");
goods[1507] =new setGoods("0000a82593","150","45","42","mb","normal");
goods[1508] =new setGoods("0000a82594","90","50","42","mb","normal");
goods[1509] =new setGoods("0000a82595","95","50","42","mb","normal");
goods[1510] =new setGoods("0000a82596","100","50","42","mb","normal");
goods[1511] =new setGoods("0000a82597","105","50","42","mb","normal");
goods[1512] =new setGoods("0000a82598","110","50","42","mb","normal");
goods[1513] =new setGoods("0000a82599","115","50","42","mb","normal");
goods[1514] =new setGoods("0000a82600","120","50","42","mb","normal");
goods[1515] =new setGoods("0000a82601","125","50","42","mb","normal");
goods[1516] =new setGoods("0000a82602","130","50","42","mb","normal");
goods[1517] =new setGoods("0000a82603","135","50","42","mb","normal");
goods[1518] =new setGoods("0000a82604","140","50","42","mb","normal");
goods[1519] =new setGoods("0000a82605","145","50","42","mb","normal");
goods[1520] =new setGoods("0000a82606","150","50","42","mb","normal");
goods[1521] =new setGoods("0000a82607","90","55","42","mb","normal");
goods[1522] =new setGoods("0000a82608","95","55","42","mb","normal");
goods[1523] =new setGoods("0000a82609","100","55","42","mb","normal");
goods[1524] =new setGoods("0000a82610","105","55","42","mb","normal");
goods[1525] =new setGoods("0000a39428","110","55","42","mb","normal");
goods[1526] =new setGoods("0000a82611","115","55","42","mb","normal");
goods[1527] =new setGoods("0000a82612","120","55","42","mb","normal");
goods[1528] =new setGoods("0000a82613","125","55","42","mb","normal");
goods[1529] =new setGoods("0000a82614","130","55","42","mb","normal");
goods[1530] =new setGoods("0000a82615","135","55","42","mb","normal");
goods[1531] =new setGoods("0000a82616","140","55","42","mb","normal");
goods[1532] =new setGoods("0000a82617","145","55","42","mb","normal");
goods[1533] =new setGoods("0000a82618","150","55","42","mb","normal");
goods[1534] =new setGoods("0000a82619","90","60","42","mb","normal");
goods[1535] =new setGoods("0000a82620","95","60","42","mb","normal");
goods[1536] =new setGoods("0000a82621","100","60","42","mb","normal");
goods[1537] =new setGoods("0000a82622","105","60","42","mb","normal");
goods[1538] =new setGoods("0000a82623","110","60","42","mb","normal");
goods[1539] =new setGoods("0000a82624","115","60","42","mb","normal");
goods[1540] =new setGoods("0000a82625","120","60","42","mb","normal");
goods[1541] =new setGoods("0000a82626","125","60","42","mb","normal");
goods[1542] =new setGoods("0000a82627","130","60","42","mb","normal");
goods[1543] =new setGoods("0000a82628","135","60","42","mb","normal");
goods[1544] =new setGoods("0000a82629","140","60","42","mb","normal");
goods[1545] =new setGoods("0000a82630","145","60","42","mb","normal");
goods[1546] =new setGoods("0000a82631","150","60","42","mb","normal");
goods[1547] =new setGoods("0000a82632","90","30","50","mb","normal");
goods[1548] =new setGoods("0000a82633","95","30","50","mb","normal");
goods[1549] =new setGoods("0000a82634","100","30","50","mb","normal");
goods[1550] =new setGoods("0000a82635","105","30","50","mb","normal");
goods[1551] =new setGoods("0000a82636","110","30","50","mb","normal");
goods[1552] =new setGoods("0000a82637","115","30","50","mb","normal");
goods[1553] =new setGoods("0000a82638","120","30","50","mb","normal");
goods[1554] =new setGoods("0000a82639","125","30","50","mb","normal");
goods[1555] =new setGoods("0000a82640","130","30","50","mb","normal");
goods[1556] =new setGoods("0000a82641","135","30","50","mb","normal");
goods[1557] =new setGoods("0000a82642","140","30","50","mb","normal");
goods[1558] =new setGoods("0000a82643","145","30","50","mb","normal");
goods[1559] =new setGoods("0000a82644","150","30","50","mb","normal");
goods[1560] =new setGoods("0000a82645","90","35","50","mb","normal");
goods[1561] =new setGoods("0000a82646","95","35","50","mb","normal");
goods[1562] =new setGoods("0000a82647","100","35","50","mb","normal");
goods[1563] =new setGoods("0000a82648","105","35","50","mb","normal");
goods[1564] =new setGoods("0000a82649","110","35","50","mb","normal");
goods[1565] =new setGoods("0000a82650","115","35","50","mb","normal");
goods[1566] =new setGoods("0000a82651","120","35","50","mb","normal");
goods[1567] =new setGoods("0000a82652","125","35","50","mb","normal");
goods[1568] =new setGoods("0000a82653","130","35","50","mb","normal");
goods[1569] =new setGoods("0000a82654","135","35","50","mb","normal");
goods[1570] =new setGoods("0000a82655","140","35","50","mb","normal");
goods[1571] =new setGoods("0000a82656","145","35","50","mb","normal");
goods[1572] =new setGoods("0000a82657","150","35","50","mb","normal");
goods[1573] =new setGoods("0000a82658","90","40","50","mb","normal");
goods[1574] =new setGoods("0000a82659","95","40","50","mb","normal");
goods[1575] =new setGoods("0000a82660","100","40","50","mb","normal");
goods[1576] =new setGoods("0000a82661","105","40","50","mb","normal");
goods[1577] =new setGoods("0000a82662","110","40","50","mb","normal");
goods[1578] =new setGoods("0000a82663","115","40","50","mb","normal");
goods[1579] =new setGoods("0000a82664","120","40","50","mb","normal");
goods[1580] =new setGoods("0000a82665","125","40","50","mb","normal");
goods[1581] =new setGoods("0000a82666","130","40","50","mb","normal");
goods[1582] =new setGoods("0000a82667","135","40","50","mb","normal");
goods[1583] =new setGoods("0000a82668","140","40","50","mb","normal");
goods[1584] =new setGoods("0000a82669","145","40","50","mb","normal");
goods[1585] =new setGoods("0000a82670","150","40","50","mb","normal");
goods[1586] =new setGoods("0000a82671","90","45","50","mb","normal");
goods[1587] =new setGoods("0000a82672","95","45","50","mb","normal");
goods[1588] =new setGoods("0000a82673","100","45","50","mb","normal");
goods[1589] =new setGoods("0000a82674","105","45","50","mb","normal");
goods[1590] =new setGoods("0000a82675","110","45","50","mb","normal");
goods[1591] =new setGoods("0000a82676","115","45","50","mb","normal");
goods[1592] =new setGoods("0000a82677","120","45","50","mb","normal");
goods[1593] =new setGoods("0000a82678","125","45","50","mb","normal");
goods[1594] =new setGoods("0000a82679","130","45","50","mb","normal");
goods[1595] =new setGoods("0000a82680","135","45","50","mb","normal");
goods[1596] =new setGoods("0000a82681","140","45","50","mb","normal");
goods[1597] =new setGoods("0000a82682","145","45","50","mb","normal");
goods[1598] =new setGoods("0000a82683","150","45","50","mb","normal");
goods[1599] =new setGoods("0000a82684","90","50","50","mb","normal");
goods[1600] =new setGoods("0000a82685","95","50","50","mb","normal");
goods[1601] =new setGoods("0000a82686","100","50","50","mb","normal");
goods[1602] =new setGoods("0000a82687","105","50","50","mb","normal");
goods[1603] =new setGoods("0000a82688","110","50","50","mb","normal");
goods[1604] =new setGoods("0000a82689","115","50","50","mb","normal");
goods[1605] =new setGoods("0000a82690","120","50","50","mb","normal");
goods[1606] =new setGoods("0000a82691","125","50","50","mb","normal");
goods[1607] =new setGoods("0000a82692","130","50","50","mb","normal");
goods[1608] =new setGoods("0000a82693","135","50","50","mb","normal");
goods[1609] =new setGoods("0000a82694","140","50","50","mb","normal");
goods[1610] =new setGoods("0000a82695","145","50","50","mb","normal");
goods[1611] =new setGoods("0000a82696","150","50","50","mb","normal");
goods[1612] =new setGoods("0000a82697","90","55","50","mb","normal");
goods[1613] =new setGoods("0000a82698","95","55","50","mb","normal");
goods[1614] =new setGoods("0000a82699","100","55","50","mb","normal");
goods[1615] =new setGoods("0000a82700","105","55","50","mb","normal");
goods[1616] =new setGoods("0000a82701","110","55","50","mb","normal");
goods[1617] =new setGoods("0000a82702","115","55","50","mb","normal");
goods[1618] =new setGoods("0000a82703","120","55","50","mb","normal");
goods[1619] =new setGoods("0000a82704","125","55","50","mb","normal");
goods[1620] =new setGoods("0000a82705","130","55","50","mb","normal");
goods[1621] =new setGoods("0000a82706","135","55","50","mb","normal");
goods[1622] =new setGoods("0000a82707","140","55","50","mb","normal");
goods[1623] =new setGoods("0000a82708","145","55","50","mb","normal");
goods[1624] =new setGoods("0000a82709","150","55","50","mb","normal");
goods[1625] =new setGoods("0000a82710","90","60","50","mb","normal");
goods[1626] =new setGoods("0000a82711","95","60","50","mb","normal");
goods[1627] =new setGoods("0000a82712","100","60","50","mb","normal");
goods[1628] =new setGoods("0000a82713","105","60","50","mb","normal");
goods[1629] =new setGoods("0000a82714","110","60","50","mb","normal");
goods[1630] =new setGoods("0000a82715","115","60","50","mb","normal");
goods[1631] =new setGoods("0000a82716","120","60","50","mb","normal");
goods[1632] =new setGoods("0000a82717","125","60","50","mb","normal");
goods[1633] =new setGoods("0000a82718","130","60","50","mb","normal");
goods[1634] =new setGoods("0000a82719","135","60","50","mb","normal");
goods[1635] =new setGoods("0000a82720","140","60","50","mb","normal");
goods[1636] =new setGoods("0000a82721","145","60","50","mb","normal");
goods[1637] =new setGoods("0000a82722","150","60","50","mb","normal");
goods[1638] =new setGoods("0000a82723","90","30","30","gs","normal");
goods[1639] =new setGoods("0000a82724","95","30","30","gs","normal");
goods[1640] =new setGoods("0000a82725","100","30","30","gs","normal");
goods[1641] =new setGoods("0000a82726","105","30","30","gs","normal");
goods[1642] =new setGoods("0000a82727","110","30","30","gs","normal");
goods[1643] =new setGoods("0000a82728","115","30","30","gs","normal");
goods[1644] =new setGoods("0000a82729","120","30","30","gs","normal");
goods[1645] =new setGoods("0000a82730","125","30","30","gs","normal");
goods[1646] =new setGoods("0000a82731","130","30","30","gs","normal");
goods[1647] =new setGoods("0000a82732","135","30","30","gs","normal");
goods[1648] =new setGoods("0000a82733","140","30","30","gs","normal");
goods[1649] =new setGoods("0000a82734","145","30","30","gs","normal");
goods[1650] =new setGoods("0000a82735","150","30","30","gs","normal");
goods[1651] =new setGoods("0000a82736","90","35","30","gs","normal");
goods[1652] =new setGoods("0000a82737","95","35","30","gs","normal");
goods[1653] =new setGoods("0000a82738","100","35","30","gs","normal");
goods[1654] =new setGoods("0000a82739","105","35","30","gs","normal");
goods[1655] =new setGoods("0000a82740","110","35","30","gs","normal");
goods[1656] =new setGoods("0000a82741","115","35","30","gs","normal");
goods[1657] =new setGoods("0000a82742","120","35","30","gs","normal");
goods[1658] =new setGoods("0000a82743","125","35","30","gs","normal");
goods[1659] =new setGoods("0000a82744","130","35","30","gs","normal");
goods[1660] =new setGoods("0000a82745","135","35","30","gs","normal");
goods[1661] =new setGoods("0000a82746","140","35","30","gs","normal");
goods[1662] =new setGoods("0000a82747","145","35","30","gs","normal");
goods[1663] =new setGoods("0000a82748","150","35","30","gs","normal");
goods[1664] =new setGoods("0000a82749","90","40","30","gs","normal");
goods[1665] =new setGoods("0000a82750","95","40","30","gs","normal");
goods[1666] =new setGoods("0000a82751","100","40","30","gs","normal");
goods[1667] =new setGoods("0000a82752","105","40","30","gs","normal");
goods[1668] =new setGoods("0000a82753","110","40","30","gs","normal");
goods[1669] =new setGoods("0000a82754","115","40","30","gs","normal");
goods[1670] =new setGoods("0000a82755","120","40","30","gs","normal");
goods[1671] =new setGoods("0000a82756","125","40","30","gs","normal");
goods[1672] =new setGoods("0000a82757","130","40","30","gs","normal");
goods[1673] =new setGoods("0000a82758","135","40","30","gs","normal");
goods[1674] =new setGoods("0000a82759","140","40","30","gs","normal");
goods[1675] =new setGoods("0000a82760","145","40","30","gs","normal");
goods[1676] =new setGoods("0000a82761","150","40","30","gs","normal");
goods[1677] =new setGoods("0000a82762","90","45","30","gs","normal");
goods[1678] =new setGoods("0000a82763","95","45","30","gs","normal");
goods[1679] =new setGoods("0000a82764","100","45","30","gs","normal");
goods[1680] =new setGoods("0000a82765","105","45","30","gs","normal");
goods[1681] =new setGoods("0000a82766","110","45","30","gs","normal");
goods[1682] =new setGoods("0000a82767","115","45","30","gs","normal");
goods[1683] =new setGoods("0000a82768","120","45","30","gs","normal");
goods[1684] =new setGoods("0000a82769","125","45","30","gs","normal");
goods[1685] =new setGoods("0000a82770","130","45","30","gs","normal");
goods[1686] =new setGoods("0000a82771","135","45","30","gs","normal");
goods[1687] =new setGoods("0000a82772","140","45","30","gs","normal");
goods[1688] =new setGoods("0000a82773","145","45","30","gs","normal");
goods[1689] =new setGoods("0000a82774","150","45","30","gs","normal");
goods[1690] =new setGoods("0000a82775","90","50","30","gs","normal");
goods[1691] =new setGoods("0000a82776","95","50","30","gs","normal");
goods[1692] =new setGoods("0000a82777","100","50","30","gs","normal");
goods[1693] =new setGoods("0000a82778","105","50","30","gs","normal");
goods[1694] =new setGoods("0000a82779","110","50","30","gs","normal");
goods[1695] =new setGoods("0000a82780","115","50","30","gs","normal");
goods[1696] =new setGoods("0000a82781","120","50","30","gs","normal");
goods[1697] =new setGoods("0000a82782","125","50","30","gs","normal");
goods[1698] =new setGoods("0000a82783","130","50","30","gs","normal");
goods[1699] =new setGoods("0000a82784","135","50","30","gs","normal");
goods[1700] =new setGoods("0000a82785","140","50","30","gs","normal");
goods[1701] =new setGoods("0000a82786","145","50","30","gs","normal");
goods[1702] =new setGoods("0000a82787","150","50","30","gs","normal");
goods[1703] =new setGoods("0000a82788","90","55","30","gs","normal");
goods[1704] =new setGoods("0000a82789","95","55","30","gs","normal");
goods[1705] =new setGoods("0000a82790","100","55","30","gs","normal");
goods[1706] =new setGoods("0000a82791","105","55","30","gs","normal");
goods[1707] =new setGoods("0000a82792","110","55","30","gs","normal");
goods[1708] =new setGoods("0000a82793","115","55","30","gs","normal");
goods[1709] =new setGoods("0000a82794","120","55","30","gs","normal");
goods[1710] =new setGoods("0000a82795","125","55","30","gs","normal");
goods[1711] =new setGoods("0000a82796","130","55","30","gs","normal");
goods[1712] =new setGoods("0000a82797","135","55","30","gs","normal");
goods[1713] =new setGoods("0000a82798","140","55","30","gs","normal");
goods[1714] =new setGoods("0000a82799","145","55","30","gs","normal");
goods[1715] =new setGoods("0000a82800","150","55","30","gs","normal");
goods[1716] =new setGoods("0000a82801","90","60","30","gs","normal");
goods[1717] =new setGoods("0000a82802","95","60","30","gs","normal");
goods[1718] =new setGoods("0000a82803","100","60","30","gs","normal");
goods[1719] =new setGoods("0000a82804","105","60","30","gs","normal");
goods[1720] =new setGoods("0000a82805","110","60","30","gs","normal");
goods[1721] =new setGoods("0000a82806","115","60","30","gs","normal");
goods[1722] =new setGoods("0000a82807","120","60","30","gs","normal");
goods[1723] =new setGoods("0000a82808","125","60","30","gs","normal");
goods[1724] =new setGoods("0000a82809","130","60","30","gs","normal");
goods[1725] =new setGoods("0000a82810","135","60","30","gs","normal");
goods[1726] =new setGoods("0000a82811","140","60","30","gs","normal");
goods[1727] =new setGoods("0000a82812","145","60","30","gs","normal");
goods[1728] =new setGoods("0000a82813","150","60","30","gs","normal");
goods[1729] =new setGoods("0000a82814","90","30","42","gs","normal");
goods[1730] =new setGoods("0000a82815","95","30","42","gs","normal");
goods[1731] =new setGoods("0000a82816","100","30","42","gs","normal");
goods[1732] =new setGoods("0000a82817","105","30","42","gs","normal");
goods[1733] =new setGoods("0000a82818","110","30","42","gs","normal");
goods[1734] =new setGoods("0000a82819","115","30","42","gs","normal");
goods[1735] =new setGoods("0000a82820","120","30","42","gs","normal");
goods[1736] =new setGoods("0000a82821","125","30","42","gs","normal");
goods[1737] =new setGoods("0000a82822","130","30","42","gs","normal");
goods[1738] =new setGoods("0000a82823","135","30","42","gs","normal");
goods[1739] =new setGoods("0000a82824","140","30","42","gs","normal");
goods[1740] =new setGoods("0000a82825","145","30","42","gs","normal");
goods[1741] =new setGoods("0000a82826","150","30","42","gs","normal");
goods[1742] =new setGoods("0000a82827","90","35","42","gs","normal");
goods[1743] =new setGoods("0000a82828","95","35","42","gs","normal");
goods[1744] =new setGoods("0000a82829","100","35","42","gs","normal");
goods[1745] =new setGoods("0000a82830","105","35","42","gs","normal");
goods[1746] =new setGoods("0000a82831","110","35","42","gs","normal");
goods[1747] =new setGoods("0000a82832","115","35","42","gs","normal");
goods[1748] =new setGoods("0000a82833","120","35","42","gs","normal");
goods[1749] =new setGoods("0000a82834","125","35","42","gs","normal");
goods[1750] =new setGoods("0000a82835","130","35","42","gs","normal");
goods[1751] =new setGoods("0000a82836","135","35","42","gs","normal");
goods[1752] =new setGoods("0000a82837","140","35","42","gs","normal");
goods[1753] =new setGoods("0000a82838","145","35","42","gs","normal");
goods[1754] =new setGoods("0000a82839","150","35","42","gs","normal");
goods[1755] =new setGoods("0000a82840","90","40","42","gs","normal");
goods[1756] =new setGoods("0000a82841","95","40","42","gs","normal");
goods[1757] =new setGoods("0000a82842","100","40","42","gs","normal");
goods[1758] =new setGoods("0000a82843","105","40","42","gs","normal");
goods[1759] =new setGoods("0000a82844","110","40","42","gs","normal");
goods[1760] =new setGoods("0000a82845","115","40","42","gs","normal");
goods[1761] =new setGoods("0000a82846","120","40","42","gs","normal");
goods[1762] =new setGoods("0000a82847","125","40","42","gs","normal");
goods[1763] =new setGoods("0000a82848","130","40","42","gs","normal");
goods[1764] =new setGoods("0000a82849","135","40","42","gs","normal");
goods[1765] =new setGoods("0000a82850","140","40","42","gs","normal");
goods[1766] =new setGoods("0000a82851","145","40","42","gs","normal");
goods[1767] =new setGoods("0000a82852","150","40","42","gs","normal");
goods[1768] =new setGoods("0000a82853","90","45","42","gs","normal");
goods[1769] =new setGoods("0000a82854","95","45","42","gs","normal");
goods[1770] =new setGoods("0000a82855","100","45","42","gs","normal");
goods[1771] =new setGoods("0000a82856","105","45","42","gs","normal");
goods[1772] =new setGoods("0000a82857","110","45","42","gs","normal");
goods[1773] =new setGoods("0000a82858","115","45","42","gs","normal");
goods[1774] =new setGoods("0000a82859","120","45","42","gs","normal");
goods[1775] =new setGoods("0000a82860","125","45","42","gs","normal");
goods[1776] =new setGoods("0000a82861","130","45","42","gs","normal");
goods[1777] =new setGoods("0000a82862","135","45","42","gs","normal");
goods[1778] =new setGoods("0000a82863","140","45","42","gs","normal");
goods[1779] =new setGoods("0000a82864","145","45","42","gs","normal");
goods[1780] =new setGoods("0000a82865","150","45","42","gs","normal");
goods[1781] =new setGoods("0000a82866","90","50","42","gs","normal");
goods[1782] =new setGoods("0000a82867","95","50","42","gs","normal");
goods[1783] =new setGoods("0000a82868","100","50","42","gs","normal");
goods[1784] =new setGoods("0000a82869","105","50","42","gs","normal");
goods[1785] =new setGoods("0000a82870","110","50","42","gs","normal");
goods[1786] =new setGoods("0000a82871","115","50","42","gs","normal");
goods[1787] =new setGoods("0000a82872","120","50","42","gs","normal");
goods[1788] =new setGoods("0000a82873","125","50","42","gs","normal");
goods[1789] =new setGoods("0000a82874","130","50","42","gs","normal");
goods[1790] =new setGoods("0000a82875","135","50","42","gs","normal");
goods[1791] =new setGoods("0000a82876","140","50","42","gs","normal");
goods[1792] =new setGoods("0000a82877","145","50","42","gs","normal");
goods[1793] =new setGoods("0000a82878","150","50","42","gs","normal");
goods[1794] =new setGoods("0000a82879","90","55","42","gs","normal");
goods[1795] =new setGoods("0000a82880","95","55","42","gs","normal");
goods[1796] =new setGoods("0000a82881","100","55","42","gs","normal");
goods[1797] =new setGoods("0000a82882","105","55","42","gs","normal");
goods[1798] =new setGoods("0000a41874","110","55","42","gs","normal");
goods[1799] =new setGoods("0000a82883","115","55","42","gs","normal");
goods[1800] =new setGoods("0000a82884","120","55","42","gs","normal");
goods[1801] =new setGoods("0000a82885","125","55","42","gs","normal");
goods[1802] =new setGoods("0000a82886","130","55","42","gs","normal");
goods[1803] =new setGoods("0000a82887","135","55","42","gs","normal");
goods[1804] =new setGoods("0000a82888","140","55","42","gs","normal");
goods[1805] =new setGoods("0000a82889","145","55","42","gs","normal");
goods[1806] =new setGoods("0000a82890","150","55","42","gs","normal");
goods[1807] =new setGoods("0000a82891","90","60","42","gs","normal");
goods[1808] =new setGoods("0000a82892","95","60","42","gs","normal");
goods[1809] =new setGoods("0000a82893","100","60","42","gs","normal");
goods[1810] =new setGoods("0000a82894","105","60","42","gs","normal");
goods[1811] =new setGoods("0000a82895","110","60","42","gs","normal");
goods[1812] =new setGoods("0000a82896","115","60","42","gs","normal");
goods[1813] =new setGoods("0000a82897","120","60","42","gs","normal");
goods[1814] =new setGoods("0000a82898","125","60","42","gs","normal");
goods[1815] =new setGoods("0000a82899","130","60","42","gs","normal");
goods[1816] =new setGoods("0000a82900","135","60","42","gs","normal");
goods[1817] =new setGoods("0000a82901","140","60","42","gs","normal");
goods[1818] =new setGoods("0000a82902","145","60","42","gs","normal");
goods[1819] =new setGoods("0000a82903","150","60","42","gs","normal");
goods[1820] =new setGoods("0000a82904","90","30","50","gs","normal");
goods[1821] =new setGoods("0000a82905","95","30","50","gs","normal");
goods[1822] =new setGoods("0000a82906","100","30","50","gs","normal");
goods[1823] =new setGoods("0000a82907","105","30","50","gs","normal");
goods[1824] =new setGoods("0000a82908","110","30","50","gs","normal");
goods[1825] =new setGoods("0000a82909","115","30","50","gs","normal");
goods[1826] =new setGoods("0000a82910","120","30","50","gs","normal");
goods[1827] =new setGoods("0000a82911","125","30","50","gs","normal");
goods[1828] =new setGoods("0000a82912","130","30","50","gs","normal");
goods[1829] =new setGoods("0000a82913","135","30","50","gs","normal");
goods[1830] =new setGoods("0000a82914","140","30","50","gs","normal");
goods[1831] =new setGoods("0000a82915","145","30","50","gs","normal");
goods[1832] =new setGoods("0000a82916","150","30","50","gs","normal");
goods[1833] =new setGoods("0000a82917","90","35","50","gs","normal");
goods[1834] =new setGoods("0000a82918","95","35","50","gs","normal");
goods[1835] =new setGoods("0000a82919","100","35","50","gs","normal");
goods[1836] =new setGoods("0000a82920","105","35","50","gs","normal");
goods[1837] =new setGoods("0000a82921","110","35","50","gs","normal");
goods[1838] =new setGoods("0000a82922","115","35","50","gs","normal");
goods[1839] =new setGoods("0000a82923","120","35","50","gs","normal");
goods[1840] =new setGoods("0000a82924","125","35","50","gs","normal");
goods[1841] =new setGoods("0000a82925","130","35","50","gs","normal");
goods[1842] =new setGoods("0000a82926","135","35","50","gs","normal");
goods[1843] =new setGoods("0000a82927","140","35","50","gs","normal");
goods[1844] =new setGoods("0000a82928","145","35","50","gs","normal");
goods[1845] =new setGoods("0000a82929","150","35","50","gs","normal");
goods[1846] =new setGoods("0000a82930","90","40","50","gs","normal");
goods[1847] =new setGoods("0000a82931","95","40","50","gs","normal");
goods[1848] =new setGoods("0000a82932","100","40","50","gs","normal");
goods[1849] =new setGoods("0000a82933","105","40","50","gs","normal");
goods[1850] =new setGoods("0000a82934","110","40","50","gs","normal");
goods[1851] =new setGoods("0000a82935","115","40","50","gs","normal");
goods[1852] =new setGoods("0000a82936","120","40","50","gs","normal");
goods[1853] =new setGoods("0000a82937","125","40","50","gs","normal");
goods[1854] =new setGoods("0000a82938","130","40","50","gs","normal");
goods[1855] =new setGoods("0000a82939","135","40","50","gs","normal");
goods[1856] =new setGoods("0000a82940","140","40","50","gs","normal");
goods[1857] =new setGoods("0000a82941","145","40","50","gs","normal");
goods[1858] =new setGoods("0000a82942","150","40","50","gs","normal");
goods[1859] =new setGoods("0000a82943","90","45","50","gs","normal");
goods[1860] =new setGoods("0000a82944","95","45","50","gs","normal");
goods[1861] =new setGoods("0000a82945","100","45","50","gs","normal");
goods[1862] =new setGoods("0000a82946","105","45","50","gs","normal");
goods[1863] =new setGoods("0000a82947","110","45","50","gs","normal");
goods[1864] =new setGoods("0000a82948","115","45","50","gs","normal");
goods[1865] =new setGoods("0000a82949","120","45","50","gs","normal");
goods[1866] =new setGoods("0000a82950","125","45","50","gs","normal");
goods[1867] =new setGoods("0000a82951","130","45","50","gs","normal");
goods[1868] =new setGoods("0000a82952","135","45","50","gs","normal");
goods[1869] =new setGoods("0000a82953","140","45","50","gs","normal");
goods[1870] =new setGoods("0000a82954","145","45","50","gs","normal");
goods[1871] =new setGoods("0000a82955","150","45","50","gs","normal");
goods[1872] =new setGoods("0000a82956","90","50","50","gs","normal");
goods[1873] =new setGoods("0000a82957","95","50","50","gs","normal");
goods[1874] =new setGoods("0000a82958","100","50","50","gs","normal");
goods[1875] =new setGoods("0000a82959","105","50","50","gs","normal");
goods[1876] =new setGoods("0000a82960","110","50","50","gs","normal");
goods[1877] =new setGoods("0000a82961","115","50","50","gs","normal");
goods[1878] =new setGoods("0000a82962","120","50","50","gs","normal");
goods[1879] =new setGoods("0000a82963","125","50","50","gs","normal");
goods[1880] =new setGoods("0000a82964","130","50","50","gs","normal");
goods[1881] =new setGoods("0000a82965","135","50","50","gs","normal");
goods[1882] =new setGoods("0000a82966","140","50","50","gs","normal");
goods[1883] =new setGoods("0000a82967","145","50","50","gs","normal");
goods[1884] =new setGoods("0000a82968","150","50","50","gs","normal");
goods[1885] =new setGoods("0000a82969","90","55","50","gs","normal");
goods[1886] =new setGoods("0000a82970","95","55","50","gs","normal");
goods[1887] =new setGoods("0000a82971","100","55","50","gs","normal");
goods[1888] =new setGoods("0000a82972","105","55","50","gs","normal");
goods[1889] =new setGoods("0000a82973","110","55","50","gs","normal");
goods[1890] =new setGoods("0000a82974","115","55","50","gs","normal");
goods[1891] =new setGoods("0000a82975","120","55","50","gs","normal");
goods[1892] =new setGoods("0000a82976","125","55","50","gs","normal");
goods[1893] =new setGoods("0000a82977","130","55","50","gs","normal");
goods[1894] =new setGoods("0000a82978","135","55","50","gs","normal");
goods[1895] =new setGoods("0000a82979","140","55","50","gs","normal");
goods[1896] =new setGoods("0000a82980","145","55","50","gs","normal");
goods[1897] =new setGoods("0000a82981","150","55","50","gs","normal");
goods[1898] =new setGoods("0000a82982","90","60","50","gs","normal");
goods[1899] =new setGoods("0000a82983","95","60","50","gs","normal");
goods[1900] =new setGoods("0000a82984","100","60","50","gs","normal");
goods[1901] =new setGoods("0000a82985","105","60","50","gs","normal");
goods[1902] =new setGoods("0000a82986","110","60","50","gs","normal");
goods[1903] =new setGoods("0000a82987","115","60","50","gs","normal");
goods[1904] =new setGoods("0000a82988","120","60","50","gs","normal");
goods[1905] =new setGoods("0000a82989","125","60","50","gs","normal");
goods[1906] =new setGoods("0000a82990","130","60","50","gs","normal");
goods[1907] =new setGoods("0000a82991","135","60","50","gs","normal");
goods[1908] =new setGoods("0000a82992","140","60","50","gs","normal");
goods[1909] =new setGoods("0000a82993","145","60","50","gs","normal");
goods[1910] =new setGoods("0000a82994","150","60","50","gs","normal");
goods[1911] =new setGoods("0000a82995","90","30","30","ww","normal");
goods[1912] =new setGoods("0000a82996","95","30","30","ww","normal");
goods[1913] =new setGoods("0000a82997","100","30","30","ww","normal");
goods[1914] =new setGoods("0000a82998","105","30","30","ww","normal");
goods[1915] =new setGoods("0000a82999","110","30","30","ww","normal");
goods[1916] =new setGoods("0000a83000","115","30","30","ww","normal");
goods[1917] =new setGoods("0000a83001","120","30","30","ww","normal");
goods[1918] =new setGoods("0000a83002","125","30","30","ww","normal");
goods[1919] =new setGoods("0000a83003","130","30","30","ww","normal");
goods[1920] =new setGoods("0000a83004","135","30","30","ww","normal");
goods[1921] =new setGoods("0000a83005","140","30","30","ww","normal");
goods[1922] =new setGoods("0000a83006","145","30","30","ww","normal");
goods[1923] =new setGoods("0000a83007","150","30","30","ww","normal");
goods[1924] =new setGoods("0000a83008","90","35","30","ww","normal");
goods[1925] =new setGoods("0000a83009","95","35","30","ww","normal");
goods[1926] =new setGoods("0000a83010","100","35","30","ww","normal");
goods[1927] =new setGoods("0000a83011","105","35","30","ww","normal");
goods[1928] =new setGoods("0000a83012","110","35","30","ww","normal");
goods[1929] =new setGoods("0000a83013","115","35","30","ww","normal");
goods[1930] =new setGoods("0000a83014","120","35","30","ww","normal");
goods[1931] =new setGoods("0000a83015","125","35","30","ww","normal");
goods[1932] =new setGoods("0000a83016","130","35","30","ww","normal");
goods[1933] =new setGoods("0000a83017","135","35","30","ww","normal");
goods[1934] =new setGoods("0000a83018","140","35","30","ww","normal");
goods[1935] =new setGoods("0000a83019","145","35","30","ww","normal");
goods[1936] =new setGoods("0000a83020","150","35","30","ww","normal");
goods[1937] =new setGoods("0000a83021","90","40","30","ww","normal");
goods[1938] =new setGoods("0000a83022","95","40","30","ww","normal");
goods[1939] =new setGoods("0000a83023","100","40","30","ww","normal");
goods[1940] =new setGoods("0000a83024","105","40","30","ww","normal");
goods[1941] =new setGoods("0000a83025","110","40","30","ww","normal");
goods[1942] =new setGoods("0000a83026","115","40","30","ww","normal");
goods[1943] =new setGoods("0000a83027","120","40","30","ww","normal");
goods[1944] =new setGoods("0000a83028","125","40","30","ww","normal");
goods[1945] =new setGoods("0000a83029","130","40","30","ww","normal");
goods[1946] =new setGoods("0000a83030","135","40","30","ww","normal");
goods[1947] =new setGoods("0000a83031","140","40","30","ww","normal");
goods[1948] =new setGoods("0000a83032","145","40","30","ww","normal");
goods[1949] =new setGoods("0000a83033","150","40","30","ww","normal");
goods[1950] =new setGoods("0000a83034","90","45","30","ww","normal");
goods[1951] =new setGoods("0000a83035","95","45","30","ww","normal");
goods[1952] =new setGoods("0000a83036","100","45","30","ww","normal");
goods[1953] =new setGoods("0000a83037","105","45","30","ww","normal");
goods[1954] =new setGoods("0000a83038","110","45","30","ww","normal");
goods[1955] =new setGoods("0000a83039","115","45","30","ww","normal");
goods[1956] =new setGoods("0000a83040","120","45","30","ww","normal");
goods[1957] =new setGoods("0000a83041","125","45","30","ww","normal");
goods[1958] =new setGoods("0000a83042","130","45","30","ww","normal");
goods[1959] =new setGoods("0000a83043","135","45","30","ww","normal");
goods[1960] =new setGoods("0000a83044","140","45","30","ww","normal");
goods[1961] =new setGoods("0000a83045","145","45","30","ww","normal");
goods[1962] =new setGoods("0000a83046","150","45","30","ww","normal");
goods[1963] =new setGoods("0000a83047","90","50","30","ww","normal");
goods[1964] =new setGoods("0000a83048","95","50","30","ww","normal");
goods[1965] =new setGoods("0000a83049","100","50","30","ww","normal");
goods[1966] =new setGoods("0000a83050","105","50","30","ww","normal");
goods[1967] =new setGoods("0000a83051","110","50","30","ww","normal");
goods[1968] =new setGoods("0000a83052","115","50","30","ww","normal");
goods[1969] =new setGoods("0000a83053","120","50","30","ww","normal");
goods[1970] =new setGoods("0000a83054","125","50","30","ww","normal");
goods[1971] =new setGoods("0000a83055","130","50","30","ww","normal");
goods[1972] =new setGoods("0000a83056","135","50","30","ww","normal");
goods[1973] =new setGoods("0000a83057","140","50","30","ww","normal");
goods[1974] =new setGoods("0000a83058","145","50","30","ww","normal");
goods[1975] =new setGoods("0000a83059","150","50","30","ww","normal");
goods[1976] =new setGoods("0000a83060","90","55","30","ww","normal");
goods[1977] =new setGoods("0000a83061","95","55","30","ww","normal");
goods[1978] =new setGoods("0000a83062","100","55","30","ww","normal");
goods[1979] =new setGoods("0000a83063","105","55","30","ww","normal");
goods[1980] =new setGoods("0000a83064","110","55","30","ww","normal");
goods[1981] =new setGoods("0000a83065","115","55","30","ww","normal");
goods[1982] =new setGoods("0000a83066","120","55","30","ww","normal");
goods[1983] =new setGoods("0000a83067","125","55","30","ww","normal");
goods[1984] =new setGoods("0000a83068","130","55","30","ww","normal");
goods[1985] =new setGoods("0000a83069","135","55","30","ww","normal");
goods[1986] =new setGoods("0000a83070","140","55","30","ww","normal");
goods[1987] =new setGoods("0000a83071","145","55","30","ww","normal");
goods[1988] =new setGoods("0000a83072","150","55","30","ww","normal");
goods[1989] =new setGoods("0000a83073","90","60","30","ww","normal");
goods[1990] =new setGoods("0000a83074","95","60","30","ww","normal");
goods[1991] =new setGoods("0000a83075","100","60","30","ww","normal");
goods[1992] =new setGoods("0000a83076","105","60","30","ww","normal");
goods[1993] =new setGoods("0000a83077","110","60","30","ww","normal");
goods[1994] =new setGoods("0000a83078","115","60","30","ww","normal");
goods[1995] =new setGoods("0000a83079","120","60","30","ww","normal");
goods[1996] =new setGoods("0000a83080","125","60","30","ww","normal");
goods[1997] =new setGoods("0000a83081","130","60","30","ww","normal");
goods[1998] =new setGoods("0000a83082","135","60","30","ww","normal");
goods[1999] =new setGoods("0000a83083","140","60","30","ww","normal");
goods[2000] =new setGoods("0000a83084","145","60","30","ww","normal");
goods[2001] =new setGoods("0000a83085","150","60","30","ww","normal");
goods[2002] =new setGoods("0000a83086","90","30","42","ww","normal");
goods[2003] =new setGoods("0000a83087","95","30","42","ww","normal");
goods[2004] =new setGoods("0000a83088","100","30","42","ww","normal");
goods[2005] =new setGoods("0000a83089","105","30","42","ww","normal");
goods[2006] =new setGoods("0000a83090","110","30","42","ww","normal");
goods[2007] =new setGoods("0000a83091","115","30","42","ww","normal");
goods[2008] =new setGoods("0000a83092","120","30","42","ww","normal");
goods[2009] =new setGoods("0000a83093","125","30","42","ww","normal");
goods[2010] =new setGoods("0000a83094","130","30","42","ww","normal");
goods[2011] =new setGoods("0000a83095","135","30","42","ww","normal");
goods[2012] =new setGoods("0000a83096","140","30","42","ww","normal");
goods[2013] =new setGoods("0000a83097","145","30","42","ww","normal");
goods[2014] =new setGoods("0000a83098","150","30","42","ww","normal");
goods[2015] =new setGoods("0000a83099","90","35","42","ww","normal");
goods[2016] =new setGoods("0000a83100","95","35","42","ww","normal");
goods[2017] =new setGoods("0000a83101","100","35","42","ww","normal");
goods[2018] =new setGoods("0000a83102","105","35","42","ww","normal");
goods[2019] =new setGoods("0000a83103","110","35","42","ww","normal");
goods[2020] =new setGoods("0000a83104","115","35","42","ww","normal");
goods[2021] =new setGoods("0000a83105","120","35","42","ww","normal");
goods[2022] =new setGoods("0000a83106","125","35","42","ww","normal");
goods[2023] =new setGoods("0000a83107","130","35","42","ww","normal");
goods[2024] =new setGoods("0000a83108","135","35","42","ww","normal");
goods[2025] =new setGoods("0000a83109","140","35","42","ww","normal");
goods[2026] =new setGoods("0000a83110","145","35","42","ww","normal");
goods[2027] =new setGoods("0000a83111","150","35","42","ww","normal");
goods[2028] =new setGoods("0000a83112","90","40","42","ww","normal");
goods[2029] =new setGoods("0000a83113","95","40","42","ww","normal");
goods[2030] =new setGoods("0000a83114","100","40","42","ww","normal");
goods[2031] =new setGoods("0000a83115","105","40","42","ww","normal");
goods[2032] =new setGoods("0000a83116","110","40","42","ww","normal");
goods[2033] =new setGoods("0000a83117","115","40","42","ww","normal");
goods[2034] =new setGoods("0000a83118","120","40","42","ww","normal");
goods[2035] =new setGoods("0000a83119","125","40","42","ww","normal");
goods[2036] =new setGoods("0000a83120","130","40","42","ww","normal");
goods[2037] =new setGoods("0000a83121","135","40","42","ww","normal");
goods[2038] =new setGoods("0000a83122","140","40","42","ww","normal");
goods[2039] =new setGoods("0000a83123","145","40","42","ww","normal");
goods[2040] =new setGoods("0000a83124","150","40","42","ww","normal");
goods[2041] =new setGoods("0000a83125","90","45","42","ww","normal");
goods[2042] =new setGoods("0000a83126","95","45","42","ww","normal");
goods[2043] =new setGoods("0000a83127","100","45","42","ww","normal");
goods[2044] =new setGoods("0000a83128","105","45","42","ww","normal");
goods[2045] =new setGoods("0000a83129","110","45","42","ww","normal");
goods[2046] =new setGoods("0000a83130","115","45","42","ww","normal");
goods[2047] =new setGoods("0000a83131","120","45","42","ww","normal");
goods[2048] =new setGoods("0000a83132","125","45","42","ww","normal");
goods[2049] =new setGoods("0000a83133","130","45","42","ww","normal");
goods[2050] =new setGoods("0000a83134","135","45","42","ww","normal");
goods[2051] =new setGoods("0000a83135","140","45","42","ww","normal");
goods[2052] =new setGoods("0000a83136","145","45","42","ww","normal");
goods[2053] =new setGoods("0000a83137","150","45","42","ww","normal");
goods[2054] =new setGoods("0000a83138","90","50","42","ww","normal");
goods[2055] =new setGoods("0000a83139","95","50","42","ww","normal");
goods[2056] =new setGoods("0000a83140","100","50","42","ww","normal");
goods[2057] =new setGoods("0000a83141","105","50","42","ww","normal");
goods[2058] =new setGoods("0000a83142","110","50","42","ww","normal");
goods[2059] =new setGoods("0000a83143","115","50","42","ww","normal");
goods[2060] =new setGoods("0000a83144","120","50","42","ww","normal");
goods[2061] =new setGoods("0000a83145","125","50","42","ww","normal");
goods[2062] =new setGoods("0000a83146","130","50","42","ww","normal");
goods[2063] =new setGoods("0000a83147","135","50","42","ww","normal");
goods[2064] =new setGoods("0000a83148","140","50","42","ww","normal");
goods[2065] =new setGoods("0000a83149","145","50","42","ww","normal");
goods[2066] =new setGoods("0000a83150","150","50","42","ww","normal");
goods[2067] =new setGoods("0000a83151","90","55","42","ww","normal");
goods[2068] =new setGoods("0000a83152","95","55","42","ww","normal");
goods[2069] =new setGoods("0000a83153","100","55","42","ww","normal");
goods[2070] =new setGoods("0000a83154","105","55","42","ww","normal");
goods[2071] =new setGoods("0000a41848","110","55","42","ww","normal");
goods[2072] =new setGoods("0000a83155","115","55","42","ww","normal");
goods[2073] =new setGoods("0000a83156","120","55","42","ww","normal");
goods[2074] =new setGoods("0000a83157","125","55","42","ww","normal");
goods[2075] =new setGoods("0000a83158","130","55","42","ww","normal");
goods[2076] =new setGoods("0000a83159","135","55","42","ww","normal");
goods[2077] =new setGoods("0000a83160","140","55","42","ww","normal");
goods[2078] =new setGoods("0000a83161","145","55","42","ww","normal");
goods[2079] =new setGoods("0000a83162","150","55","42","ww","normal");
goods[2080] =new setGoods("0000a83163","90","60","42","ww","normal");
goods[2081] =new setGoods("0000a83164","95","60","42","ww","normal");
goods[2082] =new setGoods("0000a83165","100","60","42","ww","normal");
goods[2083] =new setGoods("0000a83166","105","60","42","ww","normal");
goods[2084] =new setGoods("0000a83167","110","60","42","ww","normal");
goods[2085] =new setGoods("0000a83168","115","60","42","ww","normal");
goods[2086] =new setGoods("0000a83169","120","60","42","ww","normal");
goods[2087] =new setGoods("0000a83170","125","60","42","ww","normal");
goods[2088] =new setGoods("0000a83171","130","60","42","ww","normal");
goods[2089] =new setGoods("0000a83172","135","60","42","ww","normal");
goods[2090] =new setGoods("0000a83173","140","60","42","ww","normal");
goods[2091] =new setGoods("0000a83174","145","60","42","ww","normal");
goods[2092] =new setGoods("0000a83175","150","60","42","ww","normal");
goods[2093] =new setGoods("0000a83176","90","30","50","ww","normal");
goods[2094] =new setGoods("0000a83177","95","30","50","ww","normal");
goods[2095] =new setGoods("0000a83178","100","30","50","ww","normal");
goods[2096] =new setGoods("0000a83179","105","30","50","ww","normal");
goods[2097] =new setGoods("0000a83180","110","30","50","ww","normal");
goods[2098] =new setGoods("0000a83181","115","30","50","ww","normal");
goods[2099] =new setGoods("0000a83182","120","30","50","ww","normal");
goods[2100] =new setGoods("0000a83183","125","30","50","ww","normal");
goods[2101] =new setGoods("0000a83184","130","30","50","ww","normal");
goods[2102] =new setGoods("0000a83185","135","30","50","ww","normal");
goods[2103] =new setGoods("0000a83186","140","30","50","ww","normal");
goods[2104] =new setGoods("0000a83187","145","30","50","ww","normal");
goods[2105] =new setGoods("0000a83188","150","30","50","ww","normal");
goods[2106] =new setGoods("0000a83189","90","35","50","ww","normal");
goods[2107] =new setGoods("0000a83190","95","35","50","ww","normal");
goods[2108] =new setGoods("0000a83191","100","35","50","ww","normal");
goods[2109] =new setGoods("0000a83192","105","35","50","ww","normal");
goods[2110] =new setGoods("0000a83193","110","35","50","ww","normal");
goods[2111] =new setGoods("0000a83194","115","35","50","ww","normal");
goods[2112] =new setGoods("0000a83195","120","35","50","ww","normal");
goods[2113] =new setGoods("0000a83196","125","35","50","ww","normal");
goods[2114] =new setGoods("0000a83197","130","35","50","ww","normal");
goods[2115] =new setGoods("0000a83198","135","35","50","ww","normal");
goods[2116] =new setGoods("0000a83199","140","35","50","ww","normal");
goods[2117] =new setGoods("0000a83200","145","35","50","ww","normal");
goods[2118] =new setGoods("0000a83201","150","35","50","ww","normal");
goods[2119] =new setGoods("0000a83202","90","40","50","ww","normal");
goods[2120] =new setGoods("0000a83203","95","40","50","ww","normal");
goods[2121] =new setGoods("0000a83204","100","40","50","ww","normal");
goods[2122] =new setGoods("0000a83205","105","40","50","ww","normal");
goods[2123] =new setGoods("0000a83206","110","40","50","ww","normal");
goods[2124] =new setGoods("0000a83207","115","40","50","ww","normal");
goods[2125] =new setGoods("0000a83208","120","40","50","ww","normal");
goods[2126] =new setGoods("0000a83209","125","40","50","ww","normal");
goods[2127] =new setGoods("0000a83210","130","40","50","ww","normal");
goods[2128] =new setGoods("0000a83211","135","40","50","ww","normal");
goods[2129] =new setGoods("0000a83212","140","40","50","ww","normal");
goods[2130] =new setGoods("0000a83213","145","40","50","ww","normal");
goods[2131] =new setGoods("0000a83214","150","40","50","ww","normal");
goods[2132] =new setGoods("0000a83215","90","45","50","ww","normal");
goods[2133] =new setGoods("0000a83216","95","45","50","ww","normal");
goods[2134] =new setGoods("0000a83217","100","45","50","ww","normal");
goods[2135] =new setGoods("0000a83218","105","45","50","ww","normal");
goods[2136] =new setGoods("0000a83219","110","45","50","ww","normal");
goods[2137] =new setGoods("0000a83220","115","45","50","ww","normal");
goods[2138] =new setGoods("0000a83221","120","45","50","ww","normal");
goods[2139] =new setGoods("0000a83222","125","45","50","ww","normal");
goods[2140] =new setGoods("0000a83223","130","45","50","ww","normal");
goods[2141] =new setGoods("0000a83224","135","45","50","ww","normal");
goods[2142] =new setGoods("0000a83225","140","45","50","ww","normal");
goods[2143] =new setGoods("0000a83226","145","45","50","ww","normal");
goods[2144] =new setGoods("0000a83227","150","45","50","ww","normal");
goods[2145] =new setGoods("0000a83228","90","50","50","ww","normal");
goods[2146] =new setGoods("0000a83229","95","50","50","ww","normal");
goods[2147] =new setGoods("0000a83230","100","50","50","ww","normal");
goods[2148] =new setGoods("0000a83231","105","50","50","ww","normal");
goods[2149] =new setGoods("0000a83232","110","50","50","ww","normal");
goods[2150] =new setGoods("0000a83233","115","50","50","ww","normal");
goods[2151] =new setGoods("0000a83234","120","50","50","ww","normal");
goods[2152] =new setGoods("0000a83235","125","50","50","ww","normal");
goods[2153] =new setGoods("0000a83236","130","50","50","ww","normal");
goods[2154] =new setGoods("0000a83237","135","50","50","ww","normal");
goods[2155] =new setGoods("0000a83238","140","50","50","ww","normal");
goods[2156] =new setGoods("0000a83239","145","50","50","ww","normal");
goods[2157] =new setGoods("0000a83240","150","50","50","ww","normal");
goods[2158] =new setGoods("0000a83241","90","55","50","ww","normal");
goods[2159] =new setGoods("0000a83242","95","55","50","ww","normal");
goods[2160] =new setGoods("0000a83243","100","55","50","ww","normal");
goods[2161] =new setGoods("0000a83244","105","55","50","ww","normal");
goods[2162] =new setGoods("0000a83245","110","55","50","ww","normal");
goods[2163] =new setGoods("0000a83246","115","55","50","ww","normal");
goods[2164] =new setGoods("0000a83247","120","55","50","ww","normal");
goods[2165] =new setGoods("0000a83248","125","55","50","ww","normal");
goods[2166] =new setGoods("0000a83249","130","55","50","ww","normal");
goods[2167] =new setGoods("0000a83250","135","55","50","ww","normal");
goods[2168] =new setGoods("0000a83251","140","55","50","ww","normal");
goods[2169] =new setGoods("0000a83252","145","55","50","ww","normal");
goods[2170] =new setGoods("0000a83253","150","55","50","ww","normal");
goods[2171] =new setGoods("0000a83254","90","60","50","ww","normal");
goods[2172] =new setGoods("0000a83255","95","60","50","ww","normal");
goods[2173] =new setGoods("0000a83256","100","60","50","ww","normal");
goods[2174] =new setGoods("0000a83257","105","60","50","ww","normal");
goods[2175] =new setGoods("0000a83258","110","60","50","ww","normal");
goods[2176] =new setGoods("0000a83259","115","60","50","ww","normal");
goods[2177] =new setGoods("0000a83260","120","60","50","ww","normal");
goods[2178] =new setGoods("0000a83261","125","60","50","ww","normal");
goods[2179] =new setGoods("0000a83262","130","60","50","ww","normal");
goods[2180] =new setGoods("0000a83263","135","60","50","ww","normal");
goods[2181] =new setGoods("0000a83264","140","60","50","ww","normal");
goods[2182] =new setGoods("0000a83265","145","60","50","ww","normal");
goods[2183] =new setGoods("0000a83266","150","60","50","ww","normal");






